/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../../google/protobuf/struct';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "ClientAction": {
            "fields": {
              "fallbackBehavior": {
                "type": "squareup.client.ClientAction.FallbackBehavior",
                "id": 23,
                "rule": "optional"
              },
              "viewCheckoutApplet": {
                "type": "squareup.client.ClientAction.ViewCheckoutApplet",
                "id": 1
              },
              "viewOrdersApplet": {
                "type": "squareup.client.ClientAction.ViewOrdersApplet",
                "id": 2
              },
              "viewInvoicesApplet": {
                "type": "squareup.client.ClientAction.ViewInvoicesApplet",
                "id": 3
              },
              "viewAllInvoices": {
                "type": "squareup.client.ClientAction.ViewAllInvoices",
                "id": 4
              },
              "viewInvoice": {
                "type": "squareup.client.ClientAction.ViewInvoice",
                "id": 5
              },
              "viewTransactionsApplet": {
                "type": "squareup.client.ClientAction.ViewTransactionsApplet",
                "id": 6
              },
              "viewReportsApplet": {
                "type": "squareup.client.ClientAction.ViewReportsApplet",
                "id": 7
              },
              "viewSalesReport": {
                "type": "squareup.client.ClientAction.ViewSalesReport",
                "id": 8
              },
              "viewAllDisputes": {
                "type": "squareup.client.ClientAction.ViewAllDisputes",
                "id": 9
              },
              "viewDispute": {
                "type": "squareup.client.ClientAction.ViewDispute",
                "id": 10
              },
              "viewDepositsApplet": {
                "type": "squareup.client.ClientAction.ViewDepositsApplet",
                "id": 11
              },
              "viewAllDeposits": {
                "type": "squareup.client.ClientAction.ViewAllDeposits",
                "id": 12
              },
              "viewCustomersApplet": {
                "type": "squareup.client.ClientAction.ViewCustomersApplet",
                "id": 13
              },
              "viewCustomerMessageCenter": {
                "type": "squareup.client.ClientAction.ViewCustomerMessageCenter",
                "id": 14
              },
              "viewCustomerConversation": {
                "type": "squareup.client.ClientAction.ViewCustomerConversation",
                "id": 15
              },
              "viewItemsApplet": {
                "type": "squareup.client.ClientAction.ViewItemsApplet",
                "id": 16
              },
              "createItem": {
                "type": "squareup.client.ClientAction.CreateItem",
                "id": 17
              },
              "viewSettingsApplet": {
                "type": "squareup.client.ClientAction.ViewSettingsApplet",
                "id": 18
              },
              "viewBankAccount": {
                "type": "squareup.client.ClientAction.ViewBankAccount",
                "id": 19
              },
              "viewSupportApplet": {
                "type": "squareup.client.ClientAction.ViewSupportApplet",
                "id": 20
              },
              "viewSupportMessageCenter": {
                "type": "squareup.client.ClientAction.ViewSupportMessageCenter",
                "id": 21
              },
              "viewTutorialsAndTours": {
                "type": "squareup.client.ClientAction.ViewTutorialsAndTours",
                "id": 22
              },
              "viewDepositsSettings": {
                "type": "squareup.client.ClientAction.ViewDepositsSettings",
                "id": 24
              },
              "viewOverdueInvoices": {
                "type": "squareup.client.ClientAction.ViewOverdueInvoices",
                "id": 25
              },
              "viewFreeProcessing": {
                "type": "squareup.client.ClientAction.ViewFreeProcessing",
                "id": 26
              },
              "activateAccount": {
                "type": "squareup.client.ClientAction.ActivateAccount",
                "id": 27
              },
              "finishAccountSetup": {
                "type": "squareup.client.ClientAction.FinishAccountSetup",
                "id": 28
              },
              "linkBankAccount": {
                "type": "squareup.client.ClientAction.LinkBankAccount",
                "id": 29
              },
              "startCreateItemTutorial": {
                "type": "squareup.client.ClientAction.StartCreateItemTutorial",
                "id": 30
              },
              "startFirstPaymentTutorial": {
                "type": "squareup.client.ClientAction.StartFirstPaymentTutorial",
                "id": 31
              },
              "viewQuickAmountsSettings": {
                "type": "squareup.client.ClientAction.ViewQuickAmountsSettings",
                "id": 32
              },
              "viewSignatureReceiptSettings": {
                "type": "squareup.client.ClientAction.ViewSignatureReceiptSettings",
                "id": 33
              },
              "createOnlineCheckoutLink": {
                "type": "squareup.client.ClientAction.CreateOnlineCheckoutLink",
                "id": 34
              },
              "viewMessengerMessage": {
                "type": "squareup.client.ClientAction.ViewMessengerMessage",
                "id": 35
              },
              "viewCheckoutSettings": {
                "type": "squareup.client.ClientAction.ViewCheckoutSettings",
                "id": 36
              },
              "viewInvoicesSettings": {
                "type": "squareup.client.ClientAction.ViewInvoicesSettings",
                "id": 37
              },
              "viewLoyaltySettings": {
                "type": "squareup.client.ClientAction.ViewLoyaltySettings",
                "id": 38
              },
              "viewGiftCardsSettings": {
                "type": "squareup.client.ClientAction.ViewGiftCardsSettings",
                "id": 39
              },
              "viewOnlineCheckoutSettings": {
                "type": "squareup.client.ClientAction.ViewOnlineCheckoutSettings",
                "id": 40
              },
              "viewOpenTicketsSettings": {
                "type": "squareup.client.ClientAction.ViewOpenTicketsSettings",
                "id": 41
              },
              "viewCashManagementSettings": {
                "type": "squareup.client.ClientAction.ViewCashManagementSettings",
                "id": 42
              },
              "viewTeamManagementSettings": {
                "type": "squareup.client.ClientAction.ViewTeamManagementSettings",
                "id": 43
              },
              "viewMarketingSettings": {
                "type": "squareup.client.ClientAction.ViewMarketingSettings",
                "id": 44
              },
              "viewSquareCardHome": {
                "type": "squareup.client.ClientAction.ViewSquareCardHome",
                "id": 45
              },
              "viewReferralRewards": {
                "type": "squareup.client.ClientAction.ViewReferralRewards",
                "id": 46
              },
              "viewInvoicesAddOnsLibraryDetail": {
                "type": "squareup.client.ClientAction.ViewInvoicesAddOnsLibraryDetail",
                "id": 47
              },
              "viewLoyaltyAddOnsLibraryDetail": {
                "type": "squareup.client.ClientAction.ViewLoyaltyAddOnsLibraryDetail",
                "id": 48
              },
              "viewGiftCardsAddOnsLibraryDetail": {
                "type": "squareup.client.ClientAction.ViewGiftCardsAddOnsLibraryDetail",
                "id": 49
              },
              "viewOnlineCheckoutAddOnsLibraryDetail": {
                "type": "squareup.client.ClientAction.ViewOnlineCheckoutAddOnsLibraryDetail",
                "id": 50
              },
              "viewOpenTicketsAddOnsLibraryDetail": {
                "type": "squareup.client.ClientAction.ViewOpenTicketsAddOnsLibraryDetail",
                "id": 51
              },
              "viewCashManagementAddOnsLibraryDetail": {
                "type": "squareup.client.ClientAction.ViewCashManagementAddOnsLibraryDetail",
                "id": 52
              },
              "viewTeamManagementAddOnsLibraryDetail": {
                "type": "squareup.client.ClientAction.ViewTeamManagementAddOnsLibraryDetail",
                "id": 53
              },
              "viewMarketingAddOnsLibraryDetail": {
                "type": "squareup.client.ClientAction.ViewMarketingAddOnsLibraryDetail",
                "id": 54
              },
              "viewAddOnsLibraryAppletHome": {
                "type": "squareup.client.ClientAction.ViewAddOnsLibraryAppletHome",
                "id": 55
              },
              "viewOnlineBookingPreviewAndEdit": {
                "type": "squareup.client.ClientAction.ViewOnlineBookingPreviewAndEdit",
                "id": 56
              },
              "viewPaymentDeviceSettings": {
                "type": "squareup.client.ClientAction.ViewPaymentDeviceSettings",
                "id": 57
              },
              "viewPrinterDeviceSettings": {
                "type": "squareup.client.ClientAction.ViewPrinterDeviceSettings",
                "id": 58
              },
              "viewBarcodeScannerDeviceSettings": {
                "type": "squareup.client.ClientAction.ViewBarcodeScannerDeviceSettings",
                "id": 59
              },
              "viewScaleDeviceSettings": {
                "type": "squareup.client.ClientAction.ViewScaleDeviceSettings",
                "id": 60
              },
              "viewCashDrawerDeviceSettings": {
                "type": "squareup.client.ClientAction.ViewCashDrawerDeviceSettings",
                "id": 61
              },
              "viewStandDeviceSettings": {
                "type": "squareup.client.ClientAction.ViewStandDeviceSettings",
                "id": 62
              },
              "viewAddOnsPersonalizedStart": {
                "type": "squareup.client.ClientAction.ViewAddOnsPersonalizedStart",
                "id": 63
              },
              "viewSecuritySettings": {
                "type": "squareup.client.ClientAction.ViewSecuritySettings",
                "id": 64
              },
              "viewBuyerTerminalSettings": {
                "type": "squareup.client.ClientAction.ViewBuyerTerminalSettings",
                "id": 65
              },
              "viewTeamApplet": {
                "type": "squareup.client.ClientAction.ViewTeamApplet",
                "id": 66
              },
              "viewRoundUpForCharitySettings": {
                "type": "squareup.client.ClientAction.ViewRoundUpForCharitySettings",
                "id": 67
              },
              "viewRoundUpForCharityAddOnsLibraryDetail": {
                "type": "squareup.client.ClientAction.ViewRoundUpForCharityAddOnsLibraryDetail",
                "id": 68
              },
              "viewTextMessageMarketingSettings": {
                "type": "squareup.client.ClientAction.ViewTextMessageMarketingSettings",
                "id": 69
              },
              "viewTextMessageMarketingAddOnsLibraryDetail": {
                "type": "squareup.client.ClientAction.ViewTextMessageMarketingAddOnsLibraryDetail",
                "id": 70
              },
              "viewSupportAppletHelpSection": {
                "type": "squareup.client.ClientAction.ViewSupportAppletHelpSection",
                "id": 71
              },
              "viewPhoneReaderDeviceSettings": {
                "type": "squareup.client.ClientAction.ViewPhoneReaderDeviceSettings",
                "id": 72
              },
              "viewCalendarApplet": {
                "type": "squareup.client.ClientAction.ViewCalendarApplet",
                "id": 73
              },
              "viewSupportAppletSetupGuide": {
                "type": "squareup.client.ClientAction.ViewSupportAppletSetupGuide",
                "id": 74
              },
              "viewSupportAppletFeedbackModule": {
                "type": "squareup.client.ClientAction.ViewSupportAppletFeedbackModule",
                "id": 75
              },
              "viewOnline": {
                "type": "squareup.client.ClientAction.ViewOnline",
                "id": 76
              },
              "viewOnlineSettings": {
                "type": "squareup.client.ClientAction.ViewOnlineSettings",
                "id": 77
              },
              "viewOnlineAddOnsLibraryDetail": {
                "type": "squareup.client.ClientAction.ViewOnlineAddOnsLibraryDetail",
                "id": 78
              },
              "viewCustomizableNavigationUi": {
                "type": "squareup.client.ClientAction.ViewCustomizableNavigationUI",
                "id": 79
              },
              "viewOnlineCheckout": {
                "type": "squareup.client.ClientAction.ViewOnlineCheckout",
                "id": 80
              },
              "viewCurrentDrawer": {
                "type": "squareup.client.ClientAction.ViewCurrentDrawer",
                "id": 81
              },
              "viewBuyerSubscriptionsApplet": {
                "type": "squareup.client.ClientAction.ViewBuyerSubscriptionsApplet",
                "id": 82
              },
              "viewBuyerSubscriptionsSettings": {
                "type": "squareup.client.ClientAction.ViewBuyerSubscriptionsSettings",
                "id": 83
              },
              "viewBuyerSubscriptionsAddOnsLibraryDetail": {
                "type": "squareup.client.ClientAction.ViewBuyerSubscriptionsAddOnsLibraryDetail",
                "id": 84
              },
              "viewReferralActivity": {
                "type": "squareup.client.ClientAction.ViewReferralActivity",
                "id": 85
              },
              "viewMessengerApplet": {
                "type": "squareup.client.ClientAction.ViewMessengerApplet",
                "id": 86
              },
              "viewMessengerAddOnsLibraryDetail": {
                "type": "squareup.client.ClientAction.ViewMessengerAddOnsLibraryDetail",
                "id": 87
              },
              "viewMessengerAddOnsSettings": {
                "type": "squareup.client.ClientAction.ViewMessengerAddOnsSettings",
                "id": 88
              },
              "viewSquareCardDispute": {
                "type": "squareup.client.ClientAction.ViewSquareCardDispute",
                "id": 89
              },
              "viewShiftsApplet": {
                "type": "squareup.client.ClientAction.ViewShiftsApplet",
                "id": 90
              },
              "viewShiftsSettings": {
                "type": "squareup.client.ClientAction.ViewShiftsSettings",
                "id": 91
              },
              "viewShiftsAddOnsLibraryDetail": {
                "type": "squareup.client.ClientAction.ViewShiftsAddOnsLibraryDetail",
                "id": 92
              },
              "viewCheckoutPaymentSettings": {
                "type": "squareup.client.ClientAction.ViewCheckoutPaymentSettings",
                "id": 93
              },
              "viewRoundUpForCharityApplet": {
                "type": "squareup.client.ClientAction.ViewRoundUpForCharityApplet",
                "id": 94
              },
              "createInvoice": {
                "type": "squareup.client.ClientAction.CreateInvoice",
                "id": 95
              },
              "editConvertedInvoice": {
                "type": "squareup.client.ClientAction.EditConvertedInvoice",
                "id": 96
              },
              "finishedInvoiceConversion": {
                "type": "squareup.client.ClientAction.FinishedInvoiceConversion",
                "id": 97
              },
              "viewAllEstimates": {
                "type": "squareup.client.ClientAction.ViewAllEstimates",
                "id": 98
              },
              "viewEstimate": {
                "type": "squareup.client.ClientAction.ViewEstimate",
                "id": 99
              },
              "createEstimate": {
                "type": "squareup.client.ClientAction.CreateEstimate",
                "id": 100
              },
              "viewIposFeedbackApplet": {
                "type": "squareup.client.ClientAction.ViewIPOSFeedbackApplet",
                "id": 101
              },
              "viewStoredPaymentSettings": {
                "type": "squareup.client.ClientAction.ViewStoredPaymentSettings",
                "id": 102
              },
              "startTapToPayTutorial": {
                "type": "squareup.client.ClientAction.StartTapToPayTutorial",
                "id": 103
              },
              "viewBfdDeviceSettings": {
                "type": "squareup.client.ClientAction.ViewBfdDeviceSettings",
                "id": 104
              },
              "viewBillPayApplet": {
                "type": "squareup.client.ClientAction.ViewBillPayApplet",
                "id": 105
              },
              "createBillPayBill": {
                "type": "squareup.client.ClientAction.CreateBillPayBill",
                "id": 106
              },
              "viewBillPayBill": {
                "type": "squareup.client.ClientAction.ViewBillPayBill",
                "id": 107
              },
              "viewRecurringInvoices": {
                "type": "squareup.client.ClientAction.ViewRecurringInvoices",
                "id": 108
              },
              "viewProjectsApplet": {
                "type": "squareup.client.ClientAction.ViewProjectsApplet",
                "id": 109
              },
              "createProject": {
                "type": "squareup.client.ClientAction.CreateProject",
                "id": 110
              },
              "viewMoreTab": {
                "type": "squareup.client.ClientAction.ViewMoreTab",
                "id": 111
              },
              "viewBillPaySettings": {
                "type": "squareup.client.ClientAction.ViewBillPaySettings",
                "id": 112
              },
              "viewEmailMarketingSettings": {
                "type": "squareup.client.ClientAction.ViewEmailMarketingSettings",
                "id": 113
              },
              "viewEmailMarketingAddOnsLibraryDetail": {
                "type": "squareup.client.ClientAction.ViewEmailMarketingAddOnsLibraryDetail",
                "id": 114
              },
              "viewOfflineModeSettings": {
                "type": "squareup.client.ClientAction.ViewOfflineModeSettings",
                "id": 115
              },
              "viewSquidNetworkSettings": {
                "type": "squareup.client.ClientAction.ViewSquidNetworkSettings",
                "id": 116
              },
              "viewSquidGeneralSettings": {
                "type": "squareup.client.ClientAction.ViewSquidGeneralSettings",
                "id": 117
              },
              "viewInformationRequestsSettings": {
                "type": "squareup.client.ClientAction.ViewInformationRequestsSettings",
                "id": 118
              },
              "viewEstimatesSettings": {
                "type": "squareup.client.ClientAction.ViewEstimatesSettings",
                "id": 119
              },
              "viewEstimatesAddOnsLibraryDetail": {
                "type": "squareup.client.ClientAction.ViewEstimatesAddOnsLibraryDetail",
                "id": 120
              },
              "viewEstimatesApplet": {
                "type": "squareup.client.ClientAction.ViewEstimatesApplet",
                "id": 121
              },
              "viewBusinessInformationSettings": {
                "type": "squareup.client.ClientAction.ViewBusinessInformationSettings",
                "id": 122
              },
              "viewNotificationsApplet": {
                "type": "squareup.client.ClientAction.ViewNotificationsApplet",
                "id": 123
              },
              "viewRstFloorPlansApplet": {
                "type": "squareup.client.ClientAction.ViewRSTFloorPlansApplet",
                "id": 124
              },
              "viewRstChecksApplet": {
                "type": "squareup.client.ClientAction.ViewRSTChecksApplet",
                "id": 125
              },
              "viewBillPayAddOnsLibraryDetail": {
                "type": "squareup.client.ClientAction.ViewBillPayAddOnsLibraryDetail",
                "id": 126
              },
              "viewConfigureCustomerProfile": {
                "type": "squareup.client.ClientAction.ViewConfigureCustomerProfile",
                "id": 127
              },
              "viewRstShiftReportApplet": {
                "type": "squareup.client.ClientAction.ViewRSTShiftReportApplet",
                "id": 128
              },
              "viewIosInvoiceDefaultPaymentMethods": {
                "type": "squareup.client.ClientAction.ViewIOSInvoiceDefaultPaymentMethods",
                "id": 129
              },
              "viewIosInvoicesAppletHomeTab": {
                "type": "squareup.client.ClientAction.ViewIOSInvoicesAppletHomeTab",
                "id": 130
              },
              "viewIosInvoicesAppletHomeTabPromo": {
                "type": "squareup.client.ClientAction.ViewIOSInvoicesAppletHomeTabPromo",
                "id": 131
              },
              "viewScannerScaleDeviceSettings": {
                "type": "squareup.client.ClientAction.ViewScannerScaleDeviceSettings",
                "id": 132
              },
              "viewInventoryApplet": {
                "type": "squareup.client.ClientAction.ViewInventoryApplet",
                "id": 133
              },
              "viewContractsSettings": {
                "type": "squareup.client.ClientAction.ViewContractsSettings",
                "id": 134
              },
              "viewContractsAddOnsLibraryDetail": {
                "type": "squareup.client.ClientAction.ViewContractsAddOnsLibraryDetail",
                "id": 135
              },
              "viewContractsApplet": {
                "type": "squareup.client.ClientAction.ViewContractsApplet",
                "id": 136
              },
              "viewAiInsightOptIn": {
                "type": "squareup.client.ClientAction.ViewAIInsightOptIn",
                "id": 137
              },
              "viewTerminalApiApplet": {
                "type": "squareup.client.ClientAction.ViewTerminalApiApplet",
                "id": 138
              },
              "viewTerminalApiSettings": {
                "type": "squareup.client.ClientAction.ViewTerminalApiSettings",
                "id": 139
              },
              "viewTaxSettings": {
                "type": "squareup.client.ClientAction.ViewTaxSettings",
                "id": 140
              },
              "viewTapToPayAccountSettings": {
                "type": "squareup.client.ClientAction.ViewTapToPayAccountSettings",
                "id": 141
              },
              "viewInstantProfiles": {
                "type": "squareup.client.ClientAction.ViewInstantProfiles",
                "id": 142
              },
              "viewCurrentShiftSettings": {
                "type": "squareup.client.ClientAction.ViewCurrentShiftSettings",
                "id": 143
              },
              "viewAppointment": {
                "type": "squareup.client.ClientAction.ViewAppointment",
                "id": 144
              },
              "viewFavoritesSettings": {
                "type": "squareup.client.ClientAction.ViewFavoritesSettings",
                "id": 145
              },
              "viewDiskSpaceWarning": {
                "type": "squareup.client.ClientAction.ViewDiskSpaceWarning",
                "id": 146
              },
              "viewHardwareSettings": {
                "type": "squareup.client.ClientAction.ViewHardwareSettings",
                "id": 147
              },
              "confirmBankAccountChange": {
                "type": "squareup.client.ClientAction.ConfirmBankAccountChange",
                "id": 148
              },
              "openUniversalLink": {
                "type": "squareup.client.ClientAction.OpenUniversalLink",
                "id": 149
              },
              "pairR12": {
                "type": "squareup.client.ClientAction.PairR12",
                "id": 150
              },
              "viewPaymentsCancellationsSettings": {
                "type": "squareup.client.ClientAction.ViewPaymentsCancellationsSettings",
                "id": 151
              },
              "viewRetailSettings": {
                "type": "squareup.client.ClientAction.ViewRetailSettings",
                "id": 152
              },
              "viewRetailAddOnsLibraryDetail": {
                "type": "squareup.client.ClientAction.ViewRetailAddOnsLibraryDetail",
                "id": 153
              },
              "viewRetailApplet": {
                "type": "squareup.client.ClientAction.ViewRetailApplet",
                "id": 154
              },
              "viewSquareCreditCardHome": {
                "type": "squareup.client.ClientAction.ViewSquareCreditCardHome",
                "id": 155
              },
              "activateSquareCreditCard": {
                "type": "squareup.client.ClientAction.ActivateSquareCreditCard",
                "id": 156
              },
              "viewAddonDetail": {
                "type": "squareup.client.ClientAction.ViewAddOnDetail",
                "id": 157
              },
              "viewAddonSettings": {
                "type": "squareup.client.ClientAction.ViewAddOnSettings",
                "id": 158
              },
              "viewStaffSettings": {
                "type": "squareup.client.ClientAction.ViewStaffSettings",
                "id": 159
              },
              "viewStaffAddOnsLibraryDetail": {
                "type": "squareup.client.ClientAction.ViewStaffAddOnsLibraryDetail",
                "id": 160
              },
              "viewInvoiceAppearanceSettings": {
                "type": "squareup.client.ClientAction.ViewInvoiceAppearanceSettings",
                "id": 161
              },
              "viewPaymentMethodsSettings": {
                "type": "squareup.client.ClientAction.ViewPaymentMethodsSettings",
                "id": 162
              },
              "viewVariationsOptionsModifiersSettings": {
                "type": "squareup.client.ClientAction.ViewVariationsOptionsModifiersSettings",
                "id": 163
              },
              "viewFulfillmentTypesSettings": {
                "type": "squareup.client.ClientAction.ViewFulfillmentTypesSettings",
                "id": 164
              },
              "viewLoanOfferSet": {
                "type": "squareup.client.ClientAction.ViewLoanOfferSet",
                "id": 165
              },
              "viewSuperposCustomerSurvey": {
                "type": "squareup.client.ClientAction.ViewSuperPOSCustomerSurvey",
                "id": 166
              },
              "viewAppointmentsSettings": {
                "type": "squareup.client.ClientAction.ViewAppointmentsSettings",
                "id": 167
              },
              "viewAppointmentsHoursSettings": {
                "type": "squareup.client.ClientAction.ViewAppointmentsHoursSettings",
                "id": 168
              },
              "createAppointment": {
                "type": "squareup.client.ClientAction.CreateAppointment",
                "id": 169
              },
              "createClass": {
                "type": "squareup.client.ClientAction.CreateClass",
                "id": 170
              },
              "viewOrderHardware": {
                "type": "squareup.client.ClientAction.ViewOrderHardware",
                "id": 171
              }
            },
            "nested": {
              "FallbackBehavior": {
                "values": {
                  "UNKNOWN_DO_NOT_USE": 0,
                  "NONE": 1,
                  "VERSION_UPDATE": 2
                }
              },
              "ViewCheckoutApplet": {
                "fields": {
                  "tab": {
                    "type": "squareup.client.ClientAction.ViewCheckoutApplet.CheckoutTab",
                    "id": 1,
                    "rule": "optional"
                  },
                  "deepLinkContext": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "addonId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "paymentRequest": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "setupItems": {
                    "type": "bool",
                    "id": 5,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "CheckoutTab": {
                    "values": {
                      "KEYPAD": 0,
                      "LIBRARY": 1
                    }
                  }
                }
              },
              "ViewOrdersApplet": {
                "fields": {
                  "tab": {
                    "type": "squareup.client.ClientAction.ViewOrdersApplet.OrdersTab",
                    "id": 1,
                    "rule": "optional"
                  },
                  "infoView": {
                    "type": "squareup.client.ClientAction.ViewOrdersApplet.OrdersInfoView",
                    "id": 2,
                    "rule": "optional"
                  },
                  "enableBulkActions": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "orderId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "returnOrderId": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "OrdersTab": {
                    "values": {
                      "CHECKS": 0,
                      "ONLINE": 1,
                      "PAID": 2,
                      "CLOSED": 3,
                      "SELF_SERVE": 4,
                      "ACTIVE": 5,
                      "SCHEDULED": 6
                    }
                  },
                  "OrdersInfoView": {
                    "values": {
                      "ALL": 0,
                      "SIMPLE": 1,
                      "PICKUP": 2,
                      "DELIVERY": 3,
                      "SELFSERVE": 4,
                      "SHIPMENT": 5,
                      "OTHER": 6
                    }
                  }
                }
              },
              "ViewInvoicesApplet": {
                "fields": {}
              },
              "ViewAllInvoices": {
                "fields": {
                  "filterName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "isRecurring": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ViewInvoice": {
                "fields": {
                  "invoiceId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ViewTransactionsApplet": {
                "fields": {}
              },
              "ViewReportsApplet": {
                "fields": {
                  "startIntroTutorial": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ViewSalesReport": {
                "fields": {}
              },
              "ViewCurrentDrawer": {
                "fields": {}
              },
              "ViewAllDisputes": {
                "fields": {}
              },
              "ViewDispute": {
                "fields": {
                  "disputePaymentToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ViewDepositsApplet": {
                "fields": {}
              },
              "ViewAllDeposits": {
                "fields": {}
              },
              "ViewCustomersApplet": {
                "fields": {
                  "viewAllCustomers": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "groupToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ViewCustomerMessageCenter": {
                "fields": {}
              },
              "ViewCustomerConversation": {
                "fields": {
                  "conversationToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ViewItemsApplet": {
                "fields": {
                  "navigateToDiscounts": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "navigateToServices": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "navigateToCategories": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "CreateItem": {
                "fields": {}
              },
              "ViewSettingsApplet": {
                "fields": {}
              },
              "ViewBankAccount": {
                "fields": {}
              },
              "ViewSupportApplet": {
                "fields": {}
              },
              "ViewSupportMessageCenter": {
                "fields": {}
              },
              "ViewTutorialsAndTours": {
                "fields": {}
              },
              "ViewDepositsSettings": {
                "fields": {}
              },
              "ViewOverdueInvoices": {
                "fields": {
                  "invoiceIds": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "ViewFreeProcessing": {
                "fields": {}
              },
              "ActivateAccount": {
                "fields": {}
              },
              "FinishAccountSetup": {
                "fields": {}
              },
              "LinkBankAccount": {
                "fields": {}
              },
              "StartCreateItemTutorial": {
                "fields": {}
              },
              "StartFirstPaymentTutorial": {
                "fields": {}
              },
              "ViewQuickAmountsSettings": {
                "fields": {}
              },
              "ViewSignatureReceiptSettings": {
                "fields": {}
              },
              "CreateOnlineCheckoutLink": {
                "fields": {}
              },
              "ViewMessengerApplet": {
                "fields": {}
              },
              "ViewMessengerMessage": {
                "fields": {
                  "transcriptId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "customerToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "originatingSource": {
                    "type": "squareup.client.ClientAction.ViewMessengerMessage.Feature",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Feature": {
                    "values": {
                      "OTHER": 0,
                      "PUSH_NOTIFICATION": 1
                    }
                  }
                }
              },
              "ViewMessengerAddOnsLibraryDetail": {
                "fields": {}
              },
              "ViewMessengerAddOnsSettings": {
                "fields": {}
              },
              "ViewCheckoutSettings": {
                "fields": {}
              },
              "ViewInvoicesSettings": {
                "fields": {}
              },
              "ViewLoyaltySettings": {
                "fields": {}
              },
              "ViewGiftCardsSettings": {
                "fields": {}
              },
              "ViewOnlineCheckoutSettings": {
                "fields": {}
              },
              "ViewOnlineCheckout": {
                "fields": {
                  "checkoutLinkId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ViewOpenTicketsSettings": {
                "fields": {}
              },
              "ViewCashManagementSettings": {
                "fields": {}
              },
              "ViewTeamManagementSettings": {
                "fields": {}
              },
              "ViewMarketingSettings": {
                "fields": {}
              },
              "ViewSquareCardHome": {
                "fields": {}
              },
              "ViewReferralRewards": {
                "fields": {}
              },
              "ViewInvoicesAddOnsLibraryDetail": {
                "fields": {}
              },
              "ViewLoyaltyAddOnsLibraryDetail": {
                "fields": {}
              },
              "ViewGiftCardsAddOnsLibraryDetail": {
                "fields": {}
              },
              "ViewOnlineCheckoutAddOnsLibraryDetail": {
                "fields": {}
              },
              "ViewOpenTicketsAddOnsLibraryDetail": {
                "fields": {}
              },
              "ViewCashManagementAddOnsLibraryDetail": {
                "fields": {}
              },
              "ViewTeamManagementAddOnsLibraryDetail": {
                "fields": {}
              },
              "ViewMarketingAddOnsLibraryDetail": {
                "fields": {}
              },
              "ViewAddOnsLibraryAppletHome": {
                "fields": {}
              },
              "ViewOnlineBookingPreviewAndEdit": {
                "fields": {}
              },
              "ViewPaymentDeviceSettings": {
                "fields": {}
              },
              "ViewPrinterDeviceSettings": {
                "fields": {
                  "printerId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ViewBarcodeScannerDeviceSettings": {
                "fields": {}
              },
              "ViewScaleDeviceSettings": {
                "fields": {}
              },
              "ViewCashDrawerDeviceSettings": {
                "fields": {}
              },
              "ViewStandDeviceSettings": {
                "fields": {}
              },
              "ViewAddOnsPersonalizedStart": {
                "fields": {}
              },
              "ViewSecuritySettings": {
                "fields": {}
              },
              "ViewBuyerTerminalSettings": {
                "fields": {}
              },
              "ViewTeamApplet": {
                "fields": {}
              },
              "ViewRoundUpForCharitySettings": {
                "fields": {}
              },
              "ViewRoundUpForCharityAddOnsLibraryDetail": {
                "fields": {}
              },
              "ViewTextMessageMarketingSettings": {
                "fields": {}
              },
              "ViewTextMessageMarketingAddOnsLibraryDetail": {
                "fields": {}
              },
              "ViewSupportAppletHelpSection": {
                "fields": {}
              },
              "ViewPhoneReaderDeviceSettings": {
                "fields": {}
              },
              "ViewCalendarApplet": {
                "fields": {}
              },
              "ViewSupportAppletSetupGuide": {
                "fields": {}
              },
              "ViewSupportAppletFeedbackModule": {
                "fields": {}
              },
              "ViewOnline": {
                "fields": {}
              },
              "ViewOnlineSettings": {
                "fields": {}
              },
              "ViewOnlineAddOnsLibraryDetail": {
                "fields": {}
              },
              "ViewCustomizableNavigationUI": {
                "fields": {}
              },
              "ViewBuyerSubscriptionsAddOnsLibraryDetail": {
                "fields": {}
              },
              "ViewBuyerSubscriptionsSettings": {
                "fields": {}
              },
              "ViewBuyerSubscriptionsApplet": {
                "fields": {}
              },
              "ViewReferralActivity": {
                "fields": {}
              },
              "ViewSquareCardDispute": {
                "fields": {
                  "disputeId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ViewShiftsApplet": {
                "fields": {}
              },
              "ViewShiftsSettings": {
                "fields": {}
              },
              "ViewShiftsAddOnsLibraryDetail": {
                "fields": {}
              },
              "ViewCheckoutPaymentSettings": {
                "fields": {}
              },
              "ViewRoundUpForCharityApplet": {
                "fields": {}
              },
              "CreateInvoice": {
                "fields": {
                  "isRecurring": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "EditConvertedInvoice": {
                "fields": {
                  "invoiceId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "estimateId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FinishedInvoiceConversion": {
                "fields": {
                  "invoiceId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ViewAllEstimates": {
                "fields": {
                  "filterName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ViewEstimate": {
                "fields": {
                  "estimateId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "CreateEstimate": {
                "fields": {}
              },
              "ViewIPOSFeedbackApplet": {
                "fields": {}
              },
              "ViewStoredPaymentSettings": {
                "fields": {}
              },
              "StartTapToPayTutorial": {
                "fields": {}
              },
              "ViewBfdDeviceSettings": {
                "fields": {}
              },
              "ViewBillPayApplet": {
                "fields": {}
              },
              "CreateBillPayBill": {
                "fields": {}
              },
              "ViewBillPayBill": {
                "fields": {
                  "billId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ViewRecurringInvoices": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "title": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ViewProjectsApplet": {
                "fields": {}
              },
              "CreateProject": {
                "fields": {}
              },
              "ViewMoreTab": {
                "fields": {}
              },
              "ViewBillPaySettings": {
                "fields": {}
              },
              "ViewEmailMarketingSettings": {
                "fields": {}
              },
              "ViewEmailMarketingAddOnsLibraryDetail": {
                "fields": {}
              },
              "ViewOfflineModeSettings": {
                "fields": {}
              },
              "ViewSquidNetworkSettings": {
                "fields": {}
              },
              "ViewSquidGeneralSettings": {
                "fields": {}
              },
              "ViewInformationRequestsSettings": {
                "fields": {
                  "requestToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "requestGroupToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ViewEstimatesSettings": {
                "fields": {}
              },
              "ViewEstimatesAddOnsLibraryDetail": {
                "fields": {}
              },
              "ViewEstimatesApplet": {
                "fields": {}
              },
              "ViewBusinessInformationSettings": {
                "fields": {}
              },
              "ViewNotificationsApplet": {
                "fields": {}
              },
              "ViewRSTFloorPlansApplet": {
                "fields": {}
              },
              "ViewRSTChecksApplet": {
                "fields": {}
              },
              "ViewBillPayAddOnsLibraryDetail": {
                "fields": {}
              },
              "ViewConfigureCustomerProfile": {
                "fields": {}
              },
              "ViewRSTShiftReportApplet": {
                "fields": {}
              },
              "ViewIOSInvoiceDefaultPaymentMethods": {
                "fields": {}
              },
              "ViewIOSInvoicesAppletHomeTab": {
                "fields": {}
              },
              "ViewIOSInvoicesAppletHomeTabPromo": {
                "fields": {}
              },
              "ViewScannerScaleDeviceSettings": {
                "fields": {
                  "scannerScaleId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ViewInventoryApplet": {
                "fields": {
                  "tab": {
                    "type": "squareup.client.ClientAction.ViewInventoryApplet.InventoryFeature",
                    "id": 1,
                    "rule": "optional"
                  },
                  "deepLinkContext": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "showInventoryTour": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "InventoryFeature": {
                    "values": {
                      "LABEL_PRINTING": 0
                    }
                  }
                }
              },
              "ViewContractsSettings": {
                "fields": {}
              },
              "ViewContractsAddOnsLibraryDetail": {
                "fields": {}
              },
              "ViewContractsApplet": {
                "fields": {}
              },
              "ViewAIInsightOptIn": {
                "fields": {}
              },
              "ViewTerminalApiApplet": {
                "fields": {}
              },
              "ViewTerminalApiSettings": {
                "fields": {}
              },
              "PairR12": {
                "fields": {}
              },
              "ConfirmBankAccountChange": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "OpenUniversalLink": {
                "fields": {
                  "appletId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "action": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "params": {
                    "type": "google.protobuf.Struct",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "ViewTaxSettings": {
                "fields": {}
              },
              "ViewTapToPayAccountSettings": {
                "fields": {}
              },
              "ViewDiskSpaceWarning": {
                "fields": {}
              },
              "ViewInstantProfiles": {
                "fields": {}
              },
              "ViewCurrentShiftSettings": {
                "fields": {}
              },
              "ViewAppointment": {
                "fields": {
                  "reservationId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ViewFavoritesSettings": {
                "fields": {}
              },
              "ViewHardwareSettings": {
                "fields": {}
              },
              "ViewPaymentsCancellationsSettings": {
                "fields": {}
              },
              "ViewRetailSettings": {
                "fields": {}
              },
              "ViewRetailAddOnsLibraryDetail": {
                "fields": {}
              },
              "ViewRetailApplet": {
                "fields": {}
              },
              "ViewSquareCreditCardHome": {
                "fields": {}
              },
              "ActivateSquareCreditCard": {
                "fields": {}
              },
              "ViewAddOnDetail": {
                "fields": {
                  "addonId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ViewAddOnSettings": {
                "fields": {
                  "addonId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ViewStaffSettings": {
                "fields": {}
              },
              "ViewStaffAddOnsLibraryDetail": {
                "fields": {}
              },
              "ViewInvoiceAppearanceSettings": {
                "fields": {}
              },
              "ViewPaymentMethodsSettings": {
                "fields": {}
              },
              "ViewVariationsOptionsModifiersSettings": {
                "fields": {}
              },
              "ViewFulfillmentTypesSettings": {
                "fields": {}
              },
              "ViewLoanOfferSet": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ViewSuperPOSCustomerSurvey": {
                "fields": {}
              },
              "ViewAppointmentsSettings": {
                "fields": {}
              },
              "ViewAppointmentsHoursSettings": {
                "fields": {}
              },
              "CreateAppointment": {
                "fields": {
                  "customerToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "originatingSource": {
                    "type": "squareup.client.ClientAction.CreateAppointment.Feature",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Feature": {
                    "values": {
                      "OTHER": 0,
                      "PUSH_NOTIFICATION": 1,
                      "SETUP_GUIDE": 2
                    }
                  }
                }
              },
              "CreateClass": {
                "fields": {
                  "originatingSource": {
                    "type": "squareup.client.ClientAction.CreateClass.Feature",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Feature": {
                    "values": {
                      "OTHER": 0,
                      "SETUP_GUIDE": 1
                    }
                  }
                }
              },
              "ViewOrderHardware": {
                "fields": {}
              },
              "client_action": {
                "oneof": ["viewCheckoutApplet", "viewOrdersApplet", "viewInvoicesApplet", "viewAllInvoices", "viewInvoice", "viewTransactionsApplet", "viewReportsApplet", "viewSalesReport", "viewAllDisputes", "viewDispute", "viewDepositsApplet", "viewAllDeposits", "viewCustomersApplet", "viewCustomerMessageCenter", "viewCustomerConversation", "viewItemsApplet", "createItem", "viewSettingsApplet", "viewBankAccount", "viewSupportApplet", "viewSupportMessageCenter", "viewTutorialsAndTours", "viewDepositsSettings", "viewOverdueInvoices", "viewFreeProcessing", "activateAccount", "finishAccountSetup", "linkBankAccount", "startCreateItemTutorial", "startFirstPaymentTutorial", "viewQuickAmountsSettings", "viewSignatureReceiptSettings", "createOnlineCheckoutLink", "viewMessengerMessage", "viewCheckoutSettings", "viewInvoicesSettings", "viewLoyaltySettings", "viewGiftCardsSettings", "viewOnlineCheckoutSettings", "viewOpenTicketsSettings", "viewCashManagementSettings", "viewTeamManagementSettings", "viewMarketingSettings", "viewSquareCardHome", "viewReferralRewards", "viewInvoicesAddOnsLibraryDetail", "viewLoyaltyAddOnsLibraryDetail", "viewGiftCardsAddOnsLibraryDetail", "viewOnlineCheckoutAddOnsLibraryDetail", "viewOpenTicketsAddOnsLibraryDetail", "viewCashManagementAddOnsLibraryDetail", "viewTeamManagementAddOnsLibraryDetail", "viewMarketingAddOnsLibraryDetail", "viewAddOnsLibraryAppletHome", "viewOnlineBookingPreviewAndEdit", "viewPaymentDeviceSettings", "viewPrinterDeviceSettings", "viewBarcodeScannerDeviceSettings", "viewScaleDeviceSettings", "viewCashDrawerDeviceSettings", "viewStandDeviceSettings", "viewAddOnsPersonalizedStart", "viewSecuritySettings", "viewBuyerTerminalSettings", "viewTeamApplet", "viewRoundUpForCharitySettings", "viewRoundUpForCharityAddOnsLibraryDetail", "viewTextMessageMarketingSettings", "viewTextMessageMarketingAddOnsLibraryDetail", "viewSupportAppletHelpSection", "viewPhoneReaderDeviceSettings", "viewCalendarApplet", "viewSupportAppletSetupGuide", "viewSupportAppletFeedbackModule", "viewOnline", "viewOnlineSettings", "viewOnlineAddOnsLibraryDetail", "viewCustomizableNavigationUi", "viewOnlineCheckout", "viewCurrentDrawer", "viewBuyerSubscriptionsApplet", "viewBuyerSubscriptionsSettings", "viewBuyerSubscriptionsAddOnsLibraryDetail", "viewReferralActivity", "viewMessengerApplet", "viewMessengerAddOnsLibraryDetail", "viewMessengerAddOnsSettings", "viewSquareCardDispute", "viewShiftsApplet", "viewShiftsSettings", "viewShiftsAddOnsLibraryDetail", "viewCheckoutPaymentSettings", "viewRoundUpForCharityApplet", "createInvoice", "editConvertedInvoice", "finishedInvoiceConversion", "viewAllEstimates", "viewEstimate", "createEstimate", "viewIposFeedbackApplet", "viewStoredPaymentSettings", "startTapToPayTutorial", "viewBfdDeviceSettings", "viewBillPayApplet", "createBillPayBill", "viewBillPayBill", "viewRecurringInvoices", "viewProjectsApplet", "createProject", "viewMoreTab", "viewBillPaySettings", "viewEmailMarketingSettings", "viewEmailMarketingAddOnsLibraryDetail", "viewOfflineModeSettings", "viewSquidNetworkSettings", "viewSquidGeneralSettings", "viewInformationRequestsSettings", "viewEstimatesSettings", "viewEstimatesAddOnsLibraryDetail", "viewEstimatesApplet", "viewBusinessInformationSettings", "viewNotificationsApplet", "viewRstFloorPlansApplet", "viewRstChecksApplet", "viewBillPayAddOnsLibraryDetail", "viewConfigureCustomerProfile", "viewRstShiftReportApplet", "viewIosInvoiceDefaultPaymentMethods", "viewIosInvoicesAppletHomeTab", "viewIosInvoicesAppletHomeTabPromo", "viewScannerScaleDeviceSettings", "viewInventoryApplet", "viewContractsSettings", "viewContractsAddOnsLibraryDetail", "viewContractsApplet", "viewAiInsightOptIn", "viewTerminalApiApplet", "viewTerminalApiSettings", "viewTaxSettings", "viewTapToPayAccountSettings", "viewInstantProfiles", "viewCurrentShiftSettings", "viewAppointment", "viewFavoritesSettings", "viewDiskSpaceWarning", "viewHardwareSettings", "confirmBankAccountChange", "openUniversalLink", "pairR12", "viewPaymentsCancellationsSettings", "viewRetailSettings", "viewRetailAddOnsLibraryDetail", "viewRetailApplet", "viewSquareCreditCardHome", "activateSquareCreditCard", "viewAddonDetail", "viewAddonSettings", "viewStaffSettings", "viewStaffAddOnsLibraryDetail", "viewInvoiceAppearanceSettings", "viewPaymentMethodsSettings", "viewVariationsOptionsModifiersSettings", "viewFulfillmentTypesSettings", "viewLoanOfferSet", "viewSuperposCustomerSurvey", "viewAppointmentsSettings", "viewAppointmentsHoursSettings", "createAppointment", "createClass", "viewOrderHardware"]
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.client?.nested?.ClientAction && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.FallbackBehavior && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewCheckoutApplet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewCheckoutApplet?.nested?.CheckoutTab && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewOrdersApplet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewOrdersApplet?.nested?.OrdersTab && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewOrdersApplet?.nested?.OrdersInfoView && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewInvoicesApplet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewAllInvoices && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewInvoice && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewTransactionsApplet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewReportsApplet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewSalesReport && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewCurrentDrawer && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewAllDisputes && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewDispute && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewDepositsApplet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewAllDeposits && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewCustomersApplet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewCustomerMessageCenter && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewCustomerConversation && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewItemsApplet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.CreateItem && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewSettingsApplet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewBankAccount && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewSupportApplet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewSupportMessageCenter && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewTutorialsAndTours && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewDepositsSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewOverdueInvoices && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewFreeProcessing && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ActivateAccount && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.FinishAccountSetup && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.LinkBankAccount && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.StartCreateItemTutorial && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.StartFirstPaymentTutorial && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewQuickAmountsSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewSignatureReceiptSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.CreateOnlineCheckoutLink && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewMessengerApplet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewMessengerMessage && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewMessengerMessage?.nested?.Feature && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewMessengerAddOnsLibraryDetail && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewMessengerAddOnsSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewCheckoutSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewInvoicesSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewLoyaltySettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewGiftCardsSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewOnlineCheckoutSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewOnlineCheckout && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewOpenTicketsSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewCashManagementSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewTeamManagementSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewMarketingSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewSquareCardHome && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewReferralRewards && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewInvoicesAddOnsLibraryDetail && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewLoyaltyAddOnsLibraryDetail && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewGiftCardsAddOnsLibraryDetail && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewOnlineCheckoutAddOnsLibraryDetail && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewOpenTicketsAddOnsLibraryDetail && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewCashManagementAddOnsLibraryDetail && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewTeamManagementAddOnsLibraryDetail && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewMarketingAddOnsLibraryDetail && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewAddOnsLibraryAppletHome && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewOnlineBookingPreviewAndEdit && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewPaymentDeviceSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewPrinterDeviceSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewBarcodeScannerDeviceSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewScaleDeviceSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewCashDrawerDeviceSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewStandDeviceSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewAddOnsPersonalizedStart && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewSecuritySettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewBuyerTerminalSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewTeamApplet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewRoundUpForCharitySettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewRoundUpForCharityAddOnsLibraryDetail && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewTextMessageMarketingSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewTextMessageMarketingAddOnsLibraryDetail && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewSupportAppletHelpSection && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewPhoneReaderDeviceSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewCalendarApplet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewSupportAppletSetupGuide && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewSupportAppletFeedbackModule && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewOnline && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewOnlineSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewOnlineAddOnsLibraryDetail && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewCustomizableNavigationUI && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewBuyerSubscriptionsAddOnsLibraryDetail && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewBuyerSubscriptionsSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewBuyerSubscriptionsApplet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewReferralActivity && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewSquareCardDispute && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewShiftsApplet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewShiftsSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewShiftsAddOnsLibraryDetail && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewCheckoutPaymentSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewRoundUpForCharityApplet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.CreateInvoice && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.EditConvertedInvoice && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.FinishedInvoiceConversion && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewAllEstimates && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewEstimate && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.CreateEstimate && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewIPOSFeedbackApplet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewStoredPaymentSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.StartTapToPayTutorial && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewBfdDeviceSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewBillPayApplet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.CreateBillPayBill && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewBillPayBill && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewRecurringInvoices && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewProjectsApplet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.CreateProject && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewMoreTab && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewBillPaySettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewEmailMarketingSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewEmailMarketingAddOnsLibraryDetail && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewOfflineModeSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewSquidNetworkSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewSquidGeneralSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewInformationRequestsSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewEstimatesSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewEstimatesAddOnsLibraryDetail && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewEstimatesApplet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewBusinessInformationSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewNotificationsApplet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewRSTFloorPlansApplet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewRSTChecksApplet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewBillPayAddOnsLibraryDetail && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewConfigureCustomerProfile && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewRSTShiftReportApplet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewIOSInvoiceDefaultPaymentMethods && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewIOSInvoicesAppletHomeTab && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewIOSInvoicesAppletHomeTabPromo && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewScannerScaleDeviceSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewInventoryApplet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewInventoryApplet?.nested?.InventoryFeature && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewContractsSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewContractsAddOnsLibraryDetail && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewContractsApplet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewAIInsightOptIn && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewTerminalApiApplet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewTerminalApiSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.PairR12 && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ConfirmBankAccountChange && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.OpenUniversalLink && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewTaxSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewTapToPayAccountSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewDiskSpaceWarning && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewInstantProfiles && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewCurrentShiftSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewAppointment && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewFavoritesSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewHardwareSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewPaymentsCancellationsSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewRetailSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewRetailAddOnsLibraryDetail && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewRetailApplet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewSquareCreditCardHome && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ActivateSquareCreditCard && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewAddOnDetail && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewAddOnSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewStaffSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewStaffAddOnsLibraryDetail && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewInvoiceAppearanceSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewPaymentMethodsSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewVariationsOptionsModifiersSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewFulfillmentTypesSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewLoanOfferSet && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewSuperPOSCustomerSurvey && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewAppointmentsSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewAppointmentsHoursSettings && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.CreateAppointment && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.CreateAppointment?.nested?.Feature && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.CreateClass && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.CreateClass?.nested?.Feature && !$root.nested?.squareup?.nested?.client?.nested?.ClientAction?.nested?.ViewOrderHardware) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ClientAction @ squareup/client/client_action.proto at 14:1
 */
export const ClientAction = $root.lookupType('squareup.client.ClientAction');
fixType(ClientAction);
Builder.createAndAttachToType(ClientAction);
/**
 * SOURCE FallbackBehavior @ squareup/client/client_action.proto at 188:3
 */
ClientAction.FallbackBehavior = $root.lookupEnum('squareup.client.ClientAction.FallbackBehavior').values;
/**
 * SOURCE ViewCheckoutApplet @ squareup/client/client_action.proto at 212:3
 */
ClientAction.ViewCheckoutApplet = $root.lookupType('squareup.client.ClientAction.ViewCheckoutApplet');
fixType(ClientAction.ViewCheckoutApplet);
Builder.createAndAttachToType(ClientAction.ViewCheckoutApplet);
/**
 * SOURCE CheckoutTab @ squareup/client/client_action.proto at 218:5
 */
ClientAction.ViewCheckoutApplet.CheckoutTab = $root.lookupEnum('squareup.client.ClientAction.ViewCheckoutApplet.CheckoutTab').values;
/**
 * SOURCE ViewOrdersApplet @ squareup/client/client_action.proto at 257:3
 */
ClientAction.ViewOrdersApplet = $root.lookupType('squareup.client.ClientAction.ViewOrdersApplet');
fixType(ClientAction.ViewOrdersApplet);
Builder.createAndAttachToType(ClientAction.ViewOrdersApplet);
/**
 * SOURCE OrdersTab @ squareup/client/client_action.proto at 263:5
 */
ClientAction.ViewOrdersApplet.OrdersTab = $root.lookupEnum('squareup.client.ClientAction.ViewOrdersApplet.OrdersTab').values;
/**
 * SOURCE OrdersInfoView @ squareup/client/client_action.proto at 281:5
 */
ClientAction.ViewOrdersApplet.OrdersInfoView = $root.lookupEnum('squareup.client.ClientAction.ViewOrdersApplet.OrdersInfoView').values;
/**
 * SOURCE ViewInvoicesApplet @ squareup/client/client_action.proto at 321:3
 */
ClientAction.ViewInvoicesApplet = $root.lookupType('squareup.client.ClientAction.ViewInvoicesApplet');
fixType(ClientAction.ViewInvoicesApplet);
Builder.createAndAttachToType(ClientAction.ViewInvoicesApplet);
/**
 * SOURCE ViewAllInvoices @ squareup/client/client_action.proto at 328:3
 */
ClientAction.ViewAllInvoices = $root.lookupType('squareup.client.ClientAction.ViewAllInvoices');
fixType(ClientAction.ViewAllInvoices);
Builder.createAndAttachToType(ClientAction.ViewAllInvoices);
/**
 * SOURCE ViewInvoice @ squareup/client/client_action.proto at 349:3
 */
ClientAction.ViewInvoice = $root.lookupType('squareup.client.ClientAction.ViewInvoice');
fixType(ClientAction.ViewInvoice);
Builder.createAndAttachToType(ClientAction.ViewInvoice);
/**
 * SOURCE ViewTransactionsApplet @ squareup/client/client_action.proto at 364:3
 */
ClientAction.ViewTransactionsApplet = $root.lookupType('squareup.client.ClientAction.ViewTransactionsApplet');
fixType(ClientAction.ViewTransactionsApplet);
Builder.createAndAttachToType(ClientAction.ViewTransactionsApplet);
/**
 * SOURCE ViewReportsApplet @ squareup/client/client_action.proto at 371:3
 */
ClientAction.ViewReportsApplet = $root.lookupType('squareup.client.ClientAction.ViewReportsApplet');
fixType(ClientAction.ViewReportsApplet);
Builder.createAndAttachToType(ClientAction.ViewReportsApplet);
/**
 * SOURCE ViewSalesReport @ squareup/client/client_action.proto at 384:3
 */
ClientAction.ViewSalesReport = $root.lookupType('squareup.client.ClientAction.ViewSalesReport');
fixType(ClientAction.ViewSalesReport);
Builder.createAndAttachToType(ClientAction.ViewSalesReport);
/**
 * SOURCE ViewCurrentDrawer @ squareup/client/client_action.proto at 391:3
 */
ClientAction.ViewCurrentDrawer = $root.lookupType('squareup.client.ClientAction.ViewCurrentDrawer');
fixType(ClientAction.ViewCurrentDrawer);
Builder.createAndAttachToType(ClientAction.ViewCurrentDrawer);
/**
 * SOURCE ViewAllDisputes @ squareup/client/client_action.proto at 397:3
 */
ClientAction.ViewAllDisputes = $root.lookupType('squareup.client.ClientAction.ViewAllDisputes');
fixType(ClientAction.ViewAllDisputes);
Builder.createAndAttachToType(ClientAction.ViewAllDisputes);
/**
 * SOURCE ViewDispute @ squareup/client/client_action.proto at 404:3
 */
ClientAction.ViewDispute = $root.lookupType('squareup.client.ClientAction.ViewDispute');
fixType(ClientAction.ViewDispute);
Builder.createAndAttachToType(ClientAction.ViewDispute);
/**
 * SOURCE ViewDepositsApplet @ squareup/client/client_action.proto at 419:3
 */
ClientAction.ViewDepositsApplet = $root.lookupType('squareup.client.ClientAction.ViewDepositsApplet');
fixType(ClientAction.ViewDepositsApplet);
Builder.createAndAttachToType(ClientAction.ViewDepositsApplet);
/**
 * SOURCE ViewAllDeposits @ squareup/client/client_action.proto at 426:3
 */
ClientAction.ViewAllDeposits = $root.lookupType('squareup.client.ClientAction.ViewAllDeposits');
fixType(ClientAction.ViewAllDeposits);
Builder.createAndAttachToType(ClientAction.ViewAllDeposits);
/**
 * SOURCE ViewCustomersApplet @ squareup/client/client_action.proto at 433:3
 */
ClientAction.ViewCustomersApplet = $root.lookupType('squareup.client.ClientAction.ViewCustomersApplet');
fixType(ClientAction.ViewCustomersApplet);
Builder.createAndAttachToType(ClientAction.ViewCustomersApplet);
/**
 * SOURCE ViewCustomerMessageCenter @ squareup/client/client_action.proto at 452:3
 */
ClientAction.ViewCustomerMessageCenter = $root.lookupType('squareup.client.ClientAction.ViewCustomerMessageCenter');
fixType(ClientAction.ViewCustomerMessageCenter);
Builder.createAndAttachToType(ClientAction.ViewCustomerMessageCenter);
/**
 * SOURCE ViewCustomerConversation @ squareup/client/client_action.proto at 459:3
 */
ClientAction.ViewCustomerConversation = $root.lookupType('squareup.client.ClientAction.ViewCustomerConversation');
fixType(ClientAction.ViewCustomerConversation);
Builder.createAndAttachToType(ClientAction.ViewCustomerConversation);
/**
 * SOURCE ViewItemsApplet @ squareup/client/client_action.proto at 474:3
 */
ClientAction.ViewItemsApplet = $root.lookupType('squareup.client.ClientAction.ViewItemsApplet');
fixType(ClientAction.ViewItemsApplet);
Builder.createAndAttachToType(ClientAction.ViewItemsApplet);
/**
 * SOURCE CreateItem @ squareup/client/client_action.proto at 499:3
 */
ClientAction.CreateItem = $root.lookupType('squareup.client.ClientAction.CreateItem');
fixType(ClientAction.CreateItem);
Builder.createAndAttachToType(ClientAction.CreateItem);
/**
 * SOURCE ViewSettingsApplet @ squareup/client/client_action.proto at 506:3
 */
ClientAction.ViewSettingsApplet = $root.lookupType('squareup.client.ClientAction.ViewSettingsApplet');
fixType(ClientAction.ViewSettingsApplet);
Builder.createAndAttachToType(ClientAction.ViewSettingsApplet);
/**
 * SOURCE ViewBankAccount @ squareup/client/client_action.proto at 513:3
 */
ClientAction.ViewBankAccount = $root.lookupType('squareup.client.ClientAction.ViewBankAccount');
fixType(ClientAction.ViewBankAccount);
Builder.createAndAttachToType(ClientAction.ViewBankAccount);
/**
 * SOURCE ViewSupportApplet @ squareup/client/client_action.proto at 520:3
 */
ClientAction.ViewSupportApplet = $root.lookupType('squareup.client.ClientAction.ViewSupportApplet');
fixType(ClientAction.ViewSupportApplet);
Builder.createAndAttachToType(ClientAction.ViewSupportApplet);
/**
 * SOURCE ViewSupportMessageCenter @ squareup/client/client_action.proto at 527:3
 */
ClientAction.ViewSupportMessageCenter = $root.lookupType('squareup.client.ClientAction.ViewSupportMessageCenter');
fixType(ClientAction.ViewSupportMessageCenter);
Builder.createAndAttachToType(ClientAction.ViewSupportMessageCenter);
/**
 * SOURCE ViewTutorialsAndTours @ squareup/client/client_action.proto at 534:3
 */
ClientAction.ViewTutorialsAndTours = $root.lookupType('squareup.client.ClientAction.ViewTutorialsAndTours');
fixType(ClientAction.ViewTutorialsAndTours);
Builder.createAndAttachToType(ClientAction.ViewTutorialsAndTours);
/**
 * SOURCE ViewDepositsSettings @ squareup/client/client_action.proto at 541:3
 */
ClientAction.ViewDepositsSettings = $root.lookupType('squareup.client.ClientAction.ViewDepositsSettings');
fixType(ClientAction.ViewDepositsSettings);
Builder.createAndAttachToType(ClientAction.ViewDepositsSettings);
/**
 * SOURCE ViewOverdueInvoices @ squareup/client/client_action.proto at 548:3
 */
ClientAction.ViewOverdueInvoices = $root.lookupType('squareup.client.ClientAction.ViewOverdueInvoices');
fixType(ClientAction.ViewOverdueInvoices);
Builder.createAndAttachToType(ClientAction.ViewOverdueInvoices);
/**
 * SOURCE ViewFreeProcessing @ squareup/client/client_action.proto at 562:3
 */
ClientAction.ViewFreeProcessing = $root.lookupType('squareup.client.ClientAction.ViewFreeProcessing');
fixType(ClientAction.ViewFreeProcessing);
Builder.createAndAttachToType(ClientAction.ViewFreeProcessing);
/**
 * SOURCE ActivateAccount @ squareup/client/client_action.proto at 569:3
 */
ClientAction.ActivateAccount = $root.lookupType('squareup.client.ClientAction.ActivateAccount');
fixType(ClientAction.ActivateAccount);
Builder.createAndAttachToType(ClientAction.ActivateAccount);
/**
 * SOURCE FinishAccountSetup @ squareup/client/client_action.proto at 576:3
 */
ClientAction.FinishAccountSetup = $root.lookupType('squareup.client.ClientAction.FinishAccountSetup');
fixType(ClientAction.FinishAccountSetup);
Builder.createAndAttachToType(ClientAction.FinishAccountSetup);
/**
 * SOURCE LinkBankAccount @ squareup/client/client_action.proto at 583:3
 */
ClientAction.LinkBankAccount = $root.lookupType('squareup.client.ClientAction.LinkBankAccount');
fixType(ClientAction.LinkBankAccount);
Builder.createAndAttachToType(ClientAction.LinkBankAccount);
/**
 * SOURCE StartCreateItemTutorial @ squareup/client/client_action.proto at 590:3
 */
ClientAction.StartCreateItemTutorial = $root.lookupType('squareup.client.ClientAction.StartCreateItemTutorial');
fixType(ClientAction.StartCreateItemTutorial);
Builder.createAndAttachToType(ClientAction.StartCreateItemTutorial);
/**
 * SOURCE StartFirstPaymentTutorial @ squareup/client/client_action.proto at 597:3
 */
ClientAction.StartFirstPaymentTutorial = $root.lookupType('squareup.client.ClientAction.StartFirstPaymentTutorial');
fixType(ClientAction.StartFirstPaymentTutorial);
Builder.createAndAttachToType(ClientAction.StartFirstPaymentTutorial);
/**
 * SOURCE ViewQuickAmountsSettings @ squareup/client/client_action.proto at 604:3
 */
ClientAction.ViewQuickAmountsSettings = $root.lookupType('squareup.client.ClientAction.ViewQuickAmountsSettings');
fixType(ClientAction.ViewQuickAmountsSettings);
Builder.createAndAttachToType(ClientAction.ViewQuickAmountsSettings);
/**
 * SOURCE ViewSignatureReceiptSettings @ squareup/client/client_action.proto at 611:3
 */
ClientAction.ViewSignatureReceiptSettings = $root.lookupType('squareup.client.ClientAction.ViewSignatureReceiptSettings');
fixType(ClientAction.ViewSignatureReceiptSettings);
Builder.createAndAttachToType(ClientAction.ViewSignatureReceiptSettings);
/**
 * SOURCE CreateOnlineCheckoutLink @ squareup/client/client_action.proto at 618:3
 */
ClientAction.CreateOnlineCheckoutLink = $root.lookupType('squareup.client.ClientAction.CreateOnlineCheckoutLink');
fixType(ClientAction.CreateOnlineCheckoutLink);
Builder.createAndAttachToType(ClientAction.CreateOnlineCheckoutLink);
/**
 * SOURCE ViewMessengerApplet @ squareup/client/client_action.proto at 625:3
 */
ClientAction.ViewMessengerApplet = $root.lookupType('squareup.client.ClientAction.ViewMessengerApplet');
fixType(ClientAction.ViewMessengerApplet);
Builder.createAndAttachToType(ClientAction.ViewMessengerApplet);
/**
 * SOURCE ViewMessengerMessage @ squareup/client/client_action.proto at 632:3
 */
ClientAction.ViewMessengerMessage = $root.lookupType('squareup.client.ClientAction.ViewMessengerMessage');
fixType(ClientAction.ViewMessengerMessage);
Builder.createAndAttachToType(ClientAction.ViewMessengerMessage);
/**
 * SOURCE Feature @ squareup/client/client_action.proto at 633:5
 */
ClientAction.ViewMessengerMessage.Feature = $root.lookupEnum('squareup.client.ClientAction.ViewMessengerMessage.Feature').values;
/**
 * SOURCE ViewMessengerAddOnsLibraryDetail @ squareup/client/client_action.proto at 683:3
 */
ClientAction.ViewMessengerAddOnsLibraryDetail = $root.lookupType('squareup.client.ClientAction.ViewMessengerAddOnsLibraryDetail');
fixType(ClientAction.ViewMessengerAddOnsLibraryDetail);
Builder.createAndAttachToType(ClientAction.ViewMessengerAddOnsLibraryDetail);
/**
 * SOURCE ViewMessengerAddOnsSettings @ squareup/client/client_action.proto at 690:3
 */
ClientAction.ViewMessengerAddOnsSettings = $root.lookupType('squareup.client.ClientAction.ViewMessengerAddOnsSettings');
fixType(ClientAction.ViewMessengerAddOnsSettings);
Builder.createAndAttachToType(ClientAction.ViewMessengerAddOnsSettings);
/**
 * SOURCE ViewCheckoutSettings @ squareup/client/client_action.proto at 697:3
 */
ClientAction.ViewCheckoutSettings = $root.lookupType('squareup.client.ClientAction.ViewCheckoutSettings');
fixType(ClientAction.ViewCheckoutSettings);
Builder.createAndAttachToType(ClientAction.ViewCheckoutSettings);
/**
 * SOURCE ViewInvoicesSettings @ squareup/client/client_action.proto at 704:3
 */
ClientAction.ViewInvoicesSettings = $root.lookupType('squareup.client.ClientAction.ViewInvoicesSettings');
fixType(ClientAction.ViewInvoicesSettings);
Builder.createAndAttachToType(ClientAction.ViewInvoicesSettings);
/**
 * SOURCE ViewLoyaltySettings @ squareup/client/client_action.proto at 711:3
 */
ClientAction.ViewLoyaltySettings = $root.lookupType('squareup.client.ClientAction.ViewLoyaltySettings');
fixType(ClientAction.ViewLoyaltySettings);
Builder.createAndAttachToType(ClientAction.ViewLoyaltySettings);
/**
 * SOURCE ViewGiftCardsSettings @ squareup/client/client_action.proto at 718:3
 */
ClientAction.ViewGiftCardsSettings = $root.lookupType('squareup.client.ClientAction.ViewGiftCardsSettings');
fixType(ClientAction.ViewGiftCardsSettings);
Builder.createAndAttachToType(ClientAction.ViewGiftCardsSettings);
/**
 * SOURCE ViewOnlineCheckoutSettings @ squareup/client/client_action.proto at 725:3
 */
ClientAction.ViewOnlineCheckoutSettings = $root.lookupType('squareup.client.ClientAction.ViewOnlineCheckoutSettings');
fixType(ClientAction.ViewOnlineCheckoutSettings);
Builder.createAndAttachToType(ClientAction.ViewOnlineCheckoutSettings);
/**
 * TODO(SOC-2010): Update version.
 *
 * SOURCE ViewOnlineCheckout @ squareup/client/client_action.proto at 733:3
 */
ClientAction.ViewOnlineCheckout = $root.lookupType('squareup.client.ClientAction.ViewOnlineCheckout');
fixType(ClientAction.ViewOnlineCheckout);
Builder.createAndAttachToType(ClientAction.ViewOnlineCheckout);
/**
 * SOURCE ViewOpenTicketsSettings @ squareup/client/client_action.proto at 749:3
 */
ClientAction.ViewOpenTicketsSettings = $root.lookupType('squareup.client.ClientAction.ViewOpenTicketsSettings');
fixType(ClientAction.ViewOpenTicketsSettings);
Builder.createAndAttachToType(ClientAction.ViewOpenTicketsSettings);
/**
 * SOURCE ViewCashManagementSettings @ squareup/client/client_action.proto at 756:3
 */
ClientAction.ViewCashManagementSettings = $root.lookupType('squareup.client.ClientAction.ViewCashManagementSettings');
fixType(ClientAction.ViewCashManagementSettings);
Builder.createAndAttachToType(ClientAction.ViewCashManagementSettings);
/**
 * SOURCE ViewTeamManagementSettings @ squareup/client/client_action.proto at 763:3
 */
ClientAction.ViewTeamManagementSettings = $root.lookupType('squareup.client.ClientAction.ViewTeamManagementSettings');
fixType(ClientAction.ViewTeamManagementSettings);
Builder.createAndAttachToType(ClientAction.ViewTeamManagementSettings);
/**
 * SOURCE ViewMarketingSettings @ squareup/client/client_action.proto at 770:3
 */
ClientAction.ViewMarketingSettings = $root.lookupType('squareup.client.ClientAction.ViewMarketingSettings');
fixType(ClientAction.ViewMarketingSettings);
Builder.createAndAttachToType(ClientAction.ViewMarketingSettings);
/**
 * SOURCE ViewSquareCardHome @ squareup/client/client_action.proto at 777:3
 */
ClientAction.ViewSquareCardHome = $root.lookupType('squareup.client.ClientAction.ViewSquareCardHome');
fixType(ClientAction.ViewSquareCardHome);
Builder.createAndAttachToType(ClientAction.ViewSquareCardHome);
/**
 * SOURCE ViewReferralRewards @ squareup/client/client_action.proto at 783:3
 */
ClientAction.ViewReferralRewards = $root.lookupType('squareup.client.ClientAction.ViewReferralRewards');
fixType(ClientAction.ViewReferralRewards);
Builder.createAndAttachToType(ClientAction.ViewReferralRewards);
/**
 * SOURCE ViewInvoicesAddOnsLibraryDetail @ squareup/client/client_action.proto at 790:3
 */
ClientAction.ViewInvoicesAddOnsLibraryDetail = $root.lookupType('squareup.client.ClientAction.ViewInvoicesAddOnsLibraryDetail');
fixType(ClientAction.ViewInvoicesAddOnsLibraryDetail);
Builder.createAndAttachToType(ClientAction.ViewInvoicesAddOnsLibraryDetail);
/**
 * SOURCE ViewLoyaltyAddOnsLibraryDetail @ squareup/client/client_action.proto at 797:3
 */
ClientAction.ViewLoyaltyAddOnsLibraryDetail = $root.lookupType('squareup.client.ClientAction.ViewLoyaltyAddOnsLibraryDetail');
fixType(ClientAction.ViewLoyaltyAddOnsLibraryDetail);
Builder.createAndAttachToType(ClientAction.ViewLoyaltyAddOnsLibraryDetail);
/**
 * SOURCE ViewGiftCardsAddOnsLibraryDetail @ squareup/client/client_action.proto at 804:3
 */
ClientAction.ViewGiftCardsAddOnsLibraryDetail = $root.lookupType('squareup.client.ClientAction.ViewGiftCardsAddOnsLibraryDetail');
fixType(ClientAction.ViewGiftCardsAddOnsLibraryDetail);
Builder.createAndAttachToType(ClientAction.ViewGiftCardsAddOnsLibraryDetail);
/**
 * SOURCE ViewOnlineCheckoutAddOnsLibraryDetail @ squareup/client/client_action.proto at 811:3
 */
ClientAction.ViewOnlineCheckoutAddOnsLibraryDetail = $root.lookupType('squareup.client.ClientAction.ViewOnlineCheckoutAddOnsLibraryDetail');
fixType(ClientAction.ViewOnlineCheckoutAddOnsLibraryDetail);
Builder.createAndAttachToType(ClientAction.ViewOnlineCheckoutAddOnsLibraryDetail);
/**
 * SOURCE ViewOpenTicketsAddOnsLibraryDetail @ squareup/client/client_action.proto at 818:3
 */
ClientAction.ViewOpenTicketsAddOnsLibraryDetail = $root.lookupType('squareup.client.ClientAction.ViewOpenTicketsAddOnsLibraryDetail');
fixType(ClientAction.ViewOpenTicketsAddOnsLibraryDetail);
Builder.createAndAttachToType(ClientAction.ViewOpenTicketsAddOnsLibraryDetail);
/**
 * SOURCE ViewCashManagementAddOnsLibraryDetail @ squareup/client/client_action.proto at 825:3
 */
ClientAction.ViewCashManagementAddOnsLibraryDetail = $root.lookupType('squareup.client.ClientAction.ViewCashManagementAddOnsLibraryDetail');
fixType(ClientAction.ViewCashManagementAddOnsLibraryDetail);
Builder.createAndAttachToType(ClientAction.ViewCashManagementAddOnsLibraryDetail);
/**
 * SOURCE ViewTeamManagementAddOnsLibraryDetail @ squareup/client/client_action.proto at 832:3
 */
ClientAction.ViewTeamManagementAddOnsLibraryDetail = $root.lookupType('squareup.client.ClientAction.ViewTeamManagementAddOnsLibraryDetail');
fixType(ClientAction.ViewTeamManagementAddOnsLibraryDetail);
Builder.createAndAttachToType(ClientAction.ViewTeamManagementAddOnsLibraryDetail);
/**
 * SOURCE ViewMarketingAddOnsLibraryDetail @ squareup/client/client_action.proto at 839:3
 */
ClientAction.ViewMarketingAddOnsLibraryDetail = $root.lookupType('squareup.client.ClientAction.ViewMarketingAddOnsLibraryDetail');
fixType(ClientAction.ViewMarketingAddOnsLibraryDetail);
Builder.createAndAttachToType(ClientAction.ViewMarketingAddOnsLibraryDetail);
/**
 * SOURCE ViewAddOnsLibraryAppletHome @ squareup/client/client_action.proto at 846:3
 */
ClientAction.ViewAddOnsLibraryAppletHome = $root.lookupType('squareup.client.ClientAction.ViewAddOnsLibraryAppletHome');
fixType(ClientAction.ViewAddOnsLibraryAppletHome);
Builder.createAndAttachToType(ClientAction.ViewAddOnsLibraryAppletHome);
/**
 * SOURCE ViewOnlineBookingPreviewAndEdit @ squareup/client/client_action.proto at 852:3
 */
ClientAction.ViewOnlineBookingPreviewAndEdit = $root.lookupType('squareup.client.ClientAction.ViewOnlineBookingPreviewAndEdit');
fixType(ClientAction.ViewOnlineBookingPreviewAndEdit);
Builder.createAndAttachToType(ClientAction.ViewOnlineBookingPreviewAndEdit);
/**
 * TODO RA-45460 Support CPM specific ClientActions
 *
 * SOURCE ViewPaymentDeviceSettings @ squareup/client/client_action.proto at 859:3
 */
ClientAction.ViewPaymentDeviceSettings = $root.lookupType('squareup.client.ClientAction.ViewPaymentDeviceSettings');
fixType(ClientAction.ViewPaymentDeviceSettings);
Builder.createAndAttachToType(ClientAction.ViewPaymentDeviceSettings);
/**
 * SOURCE ViewPrinterDeviceSettings @ squareup/client/client_action.proto at 865:3
 */
ClientAction.ViewPrinterDeviceSettings = $root.lookupType('squareup.client.ClientAction.ViewPrinterDeviceSettings');
fixType(ClientAction.ViewPrinterDeviceSettings);
Builder.createAndAttachToType(ClientAction.ViewPrinterDeviceSettings);
/**
 * SOURCE ViewBarcodeScannerDeviceSettings @ squareup/client/client_action.proto at 878:3
 */
ClientAction.ViewBarcodeScannerDeviceSettings = $root.lookupType('squareup.client.ClientAction.ViewBarcodeScannerDeviceSettings');
fixType(ClientAction.ViewBarcodeScannerDeviceSettings);
Builder.createAndAttachToType(ClientAction.ViewBarcodeScannerDeviceSettings);
/**
 * SOURCE ViewScaleDeviceSettings @ squareup/client/client_action.proto at 884:3
 */
ClientAction.ViewScaleDeviceSettings = $root.lookupType('squareup.client.ClientAction.ViewScaleDeviceSettings');
fixType(ClientAction.ViewScaleDeviceSettings);
Builder.createAndAttachToType(ClientAction.ViewScaleDeviceSettings);
/**
 * SOURCE ViewCashDrawerDeviceSettings @ squareup/client/client_action.proto at 890:3
 */
ClientAction.ViewCashDrawerDeviceSettings = $root.lookupType('squareup.client.ClientAction.ViewCashDrawerDeviceSettings');
fixType(ClientAction.ViewCashDrawerDeviceSettings);
Builder.createAndAttachToType(ClientAction.ViewCashDrawerDeviceSettings);
/**
 * SOURCE ViewStandDeviceSettings @ squareup/client/client_action.proto at 896:3
 */
ClientAction.ViewStandDeviceSettings = $root.lookupType('squareup.client.ClientAction.ViewStandDeviceSettings');
fixType(ClientAction.ViewStandDeviceSettings);
Builder.createAndAttachToType(ClientAction.ViewStandDeviceSettings);
/**
 * SOURCE ViewAddOnsPersonalizedStart @ squareup/client/client_action.proto at 902:3
 */
ClientAction.ViewAddOnsPersonalizedStart = $root.lookupType('squareup.client.ClientAction.ViewAddOnsPersonalizedStart');
fixType(ClientAction.ViewAddOnsPersonalizedStart);
Builder.createAndAttachToType(ClientAction.ViewAddOnsPersonalizedStart);
/**
 * SOURCE ViewSecuritySettings @ squareup/client/client_action.proto at 909:3
 */
ClientAction.ViewSecuritySettings = $root.lookupType('squareup.client.ClientAction.ViewSecuritySettings');
fixType(ClientAction.ViewSecuritySettings);
Builder.createAndAttachToType(ClientAction.ViewSecuritySettings);
/**
 * SOURCE ViewBuyerTerminalSettings @ squareup/client/client_action.proto at 916:3
 */
ClientAction.ViewBuyerTerminalSettings = $root.lookupType('squareup.client.ClientAction.ViewBuyerTerminalSettings');
fixType(ClientAction.ViewBuyerTerminalSettings);
Builder.createAndAttachToType(ClientAction.ViewBuyerTerminalSettings);
/**
 * SOURCE ViewTeamApplet @ squareup/client/client_action.proto at 923:3
 */
ClientAction.ViewTeamApplet = $root.lookupType('squareup.client.ClientAction.ViewTeamApplet');
fixType(ClientAction.ViewTeamApplet);
Builder.createAndAttachToType(ClientAction.ViewTeamApplet);
/**
 * SOURCE ViewRoundUpForCharitySettings @ squareup/client/client_action.proto at 930:3
 */
ClientAction.ViewRoundUpForCharitySettings = $root.lookupType('squareup.client.ClientAction.ViewRoundUpForCharitySettings');
fixType(ClientAction.ViewRoundUpForCharitySettings);
Builder.createAndAttachToType(ClientAction.ViewRoundUpForCharitySettings);
/**
 * SOURCE ViewRoundUpForCharityAddOnsLibraryDetail @ squareup/client/client_action.proto at 937:3
 */
ClientAction.ViewRoundUpForCharityAddOnsLibraryDetail = $root.lookupType('squareup.client.ClientAction.ViewRoundUpForCharityAddOnsLibraryDetail');
fixType(ClientAction.ViewRoundUpForCharityAddOnsLibraryDetail);
Builder.createAndAttachToType(ClientAction.ViewRoundUpForCharityAddOnsLibraryDetail);
/**
 * SOURCE ViewTextMessageMarketingSettings @ squareup/client/client_action.proto at 944:3
 */
ClientAction.ViewTextMessageMarketingSettings = $root.lookupType('squareup.client.ClientAction.ViewTextMessageMarketingSettings');
fixType(ClientAction.ViewTextMessageMarketingSettings);
Builder.createAndAttachToType(ClientAction.ViewTextMessageMarketingSettings);
/**
 * SOURCE ViewTextMessageMarketingAddOnsLibraryDetail @ squareup/client/client_action.proto at 951:3
 */
ClientAction.ViewTextMessageMarketingAddOnsLibraryDetail = $root.lookupType('squareup.client.ClientAction.ViewTextMessageMarketingAddOnsLibraryDetail');
fixType(ClientAction.ViewTextMessageMarketingAddOnsLibraryDetail);
Builder.createAndAttachToType(ClientAction.ViewTextMessageMarketingAddOnsLibraryDetail);
/**
 * SOURCE ViewSupportAppletHelpSection @ squareup/client/client_action.proto at 958:3
 */
ClientAction.ViewSupportAppletHelpSection = $root.lookupType('squareup.client.ClientAction.ViewSupportAppletHelpSection');
fixType(ClientAction.ViewSupportAppletHelpSection);
Builder.createAndAttachToType(ClientAction.ViewSupportAppletHelpSection);
/**
 * SOURCE ViewPhoneReaderDeviceSettings @ squareup/client/client_action.proto at 965:3
 */
ClientAction.ViewPhoneReaderDeviceSettings = $root.lookupType('squareup.client.ClientAction.ViewPhoneReaderDeviceSettings');
fixType(ClientAction.ViewPhoneReaderDeviceSettings);
Builder.createAndAttachToType(ClientAction.ViewPhoneReaderDeviceSettings);
/**
 * SOURCE ViewCalendarApplet @ squareup/client/client_action.proto at 971:3
 */
ClientAction.ViewCalendarApplet = $root.lookupType('squareup.client.ClientAction.ViewCalendarApplet');
fixType(ClientAction.ViewCalendarApplet);
Builder.createAndAttachToType(ClientAction.ViewCalendarApplet);
/**
 * SOURCE ViewSupportAppletSetupGuide @ squareup/client/client_action.proto at 978:3
 */
ClientAction.ViewSupportAppletSetupGuide = $root.lookupType('squareup.client.ClientAction.ViewSupportAppletSetupGuide');
fixType(ClientAction.ViewSupportAppletSetupGuide);
Builder.createAndAttachToType(ClientAction.ViewSupportAppletSetupGuide);
/**
 * SOURCE ViewSupportAppletFeedbackModule @ squareup/client/client_action.proto at 985:3
 */
ClientAction.ViewSupportAppletFeedbackModule = $root.lookupType('squareup.client.ClientAction.ViewSupportAppletFeedbackModule');
fixType(ClientAction.ViewSupportAppletFeedbackModule);
Builder.createAndAttachToType(ClientAction.ViewSupportAppletFeedbackModule);
/**
 * SOURCE ViewOnline @ squareup/client/client_action.proto at 992:3
 */
ClientAction.ViewOnline = $root.lookupType('squareup.client.ClientAction.ViewOnline');
fixType(ClientAction.ViewOnline);
Builder.createAndAttachToType(ClientAction.ViewOnline);
/**
 * SOURCE ViewOnlineSettings @ squareup/client/client_action.proto at 999:3
 */
ClientAction.ViewOnlineSettings = $root.lookupType('squareup.client.ClientAction.ViewOnlineSettings');
fixType(ClientAction.ViewOnlineSettings);
Builder.createAndAttachToType(ClientAction.ViewOnlineSettings);
/**
 * SOURCE ViewOnlineAddOnsLibraryDetail @ squareup/client/client_action.proto at 1006:3
 */
ClientAction.ViewOnlineAddOnsLibraryDetail = $root.lookupType('squareup.client.ClientAction.ViewOnlineAddOnsLibraryDetail');
fixType(ClientAction.ViewOnlineAddOnsLibraryDetail);
Builder.createAndAttachToType(ClientAction.ViewOnlineAddOnsLibraryDetail);
/**
 * SOURCE ViewCustomizableNavigationUI @ squareup/client/client_action.proto at 1013:3
 */
ClientAction.ViewCustomizableNavigationUI = $root.lookupType('squareup.client.ClientAction.ViewCustomizableNavigationUI');
fixType(ClientAction.ViewCustomizableNavigationUI);
Builder.createAndAttachToType(ClientAction.ViewCustomizableNavigationUI);
/**
 * SOURCE ViewBuyerSubscriptionsAddOnsLibraryDetail @ squareup/client/client_action.proto at 1020:3
 */
ClientAction.ViewBuyerSubscriptionsAddOnsLibraryDetail = $root.lookupType('squareup.client.ClientAction.ViewBuyerSubscriptionsAddOnsLibraryDetail');
fixType(ClientAction.ViewBuyerSubscriptionsAddOnsLibraryDetail);
Builder.createAndAttachToType(ClientAction.ViewBuyerSubscriptionsAddOnsLibraryDetail);
/**
 * SOURCE ViewBuyerSubscriptionsSettings @ squareup/client/client_action.proto at 1027:3
 */
ClientAction.ViewBuyerSubscriptionsSettings = $root.lookupType('squareup.client.ClientAction.ViewBuyerSubscriptionsSettings');
fixType(ClientAction.ViewBuyerSubscriptionsSettings);
Builder.createAndAttachToType(ClientAction.ViewBuyerSubscriptionsSettings);
/**
 * SOURCE ViewBuyerSubscriptionsApplet @ squareup/client/client_action.proto at 1034:3
 */
ClientAction.ViewBuyerSubscriptionsApplet = $root.lookupType('squareup.client.ClientAction.ViewBuyerSubscriptionsApplet');
fixType(ClientAction.ViewBuyerSubscriptionsApplet);
Builder.createAndAttachToType(ClientAction.ViewBuyerSubscriptionsApplet);
/**
 * SOURCE ViewReferralActivity @ squareup/client/client_action.proto at 1041:3
 */
ClientAction.ViewReferralActivity = $root.lookupType('squareup.client.ClientAction.ViewReferralActivity');
fixType(ClientAction.ViewReferralActivity);
Builder.createAndAttachToType(ClientAction.ViewReferralActivity);
/**
 * SOURCE ViewSquareCardDispute @ squareup/client/client_action.proto at 1048:3
 */
ClientAction.ViewSquareCardDispute = $root.lookupType('squareup.client.ClientAction.ViewSquareCardDispute');
fixType(ClientAction.ViewSquareCardDispute);
Builder.createAndAttachToType(ClientAction.ViewSquareCardDispute);
/**
 * SOURCE ViewShiftsApplet @ squareup/client/client_action.proto at 1061:3
 */
ClientAction.ViewShiftsApplet = $root.lookupType('squareup.client.ClientAction.ViewShiftsApplet');
fixType(ClientAction.ViewShiftsApplet);
Builder.createAndAttachToType(ClientAction.ViewShiftsApplet);
/**
 * SOURCE ViewShiftsSettings @ squareup/client/client_action.proto at 1068:3
 */
ClientAction.ViewShiftsSettings = $root.lookupType('squareup.client.ClientAction.ViewShiftsSettings');
fixType(ClientAction.ViewShiftsSettings);
Builder.createAndAttachToType(ClientAction.ViewShiftsSettings);
/**
 * SOURCE ViewShiftsAddOnsLibraryDetail @ squareup/client/client_action.proto at 1075:3
 */
ClientAction.ViewShiftsAddOnsLibraryDetail = $root.lookupType('squareup.client.ClientAction.ViewShiftsAddOnsLibraryDetail');
fixType(ClientAction.ViewShiftsAddOnsLibraryDetail);
Builder.createAndAttachToType(ClientAction.ViewShiftsAddOnsLibraryDetail);
/**
 * SOURCE ViewCheckoutPaymentSettings @ squareup/client/client_action.proto at 1082:3
 */
ClientAction.ViewCheckoutPaymentSettings = $root.lookupType('squareup.client.ClientAction.ViewCheckoutPaymentSettings');
fixType(ClientAction.ViewCheckoutPaymentSettings);
Builder.createAndAttachToType(ClientAction.ViewCheckoutPaymentSettings);
/**
 * SOURCE ViewRoundUpForCharityApplet @ squareup/client/client_action.proto at 1089:3
 */
ClientAction.ViewRoundUpForCharityApplet = $root.lookupType('squareup.client.ClientAction.ViewRoundUpForCharityApplet');
fixType(ClientAction.ViewRoundUpForCharityApplet);
Builder.createAndAttachToType(ClientAction.ViewRoundUpForCharityApplet);
/**
 * SOURCE CreateInvoice @ squareup/client/client_action.proto at 1096:3
 */
ClientAction.CreateInvoice = $root.lookupType('squareup.client.ClientAction.CreateInvoice');
fixType(ClientAction.CreateInvoice);
Builder.createAndAttachToType(ClientAction.CreateInvoice);
/**
 * SOURCE EditConvertedInvoice @ squareup/client/client_action.proto at 1109:3
 */
ClientAction.EditConvertedInvoice = $root.lookupType('squareup.client.ClientAction.EditConvertedInvoice');
fixType(ClientAction.EditConvertedInvoice);
Builder.createAndAttachToType(ClientAction.EditConvertedInvoice);
/**
 * SOURCE FinishedInvoiceConversion @ squareup/client/client_action.proto at 1128:3
 */
ClientAction.FinishedInvoiceConversion = $root.lookupType('squareup.client.ClientAction.FinishedInvoiceConversion');
fixType(ClientAction.FinishedInvoiceConversion);
Builder.createAndAttachToType(ClientAction.FinishedInvoiceConversion);
/**
 * SOURCE ViewAllEstimates @ squareup/client/client_action.proto at 1141:3
 */
ClientAction.ViewAllEstimates = $root.lookupType('squareup.client.ClientAction.ViewAllEstimates');
fixType(ClientAction.ViewAllEstimates);
Builder.createAndAttachToType(ClientAction.ViewAllEstimates);
/**
 * SOURCE ViewEstimate @ squareup/client/client_action.proto at 1154:3
 */
ClientAction.ViewEstimate = $root.lookupType('squareup.client.ClientAction.ViewEstimate');
fixType(ClientAction.ViewEstimate);
Builder.createAndAttachToType(ClientAction.ViewEstimate);
/**
 * SOURCE CreateEstimate @ squareup/client/client_action.proto at 1167:3
 */
ClientAction.CreateEstimate = $root.lookupType('squareup.client.ClientAction.CreateEstimate');
fixType(ClientAction.CreateEstimate);
Builder.createAndAttachToType(ClientAction.CreateEstimate);
/**
 * SOURCE ViewIPOSFeedbackApplet @ squareup/client/client_action.proto at 1173:3
 */
ClientAction.ViewIPOSFeedbackApplet = $root.lookupType('squareup.client.ClientAction.ViewIPOSFeedbackApplet');
fixType(ClientAction.ViewIPOSFeedbackApplet);
Builder.createAndAttachToType(ClientAction.ViewIPOSFeedbackApplet);
/**
 * SOURCE ViewStoredPaymentSettings @ squareup/client/client_action.proto at 1179:3
 */
ClientAction.ViewStoredPaymentSettings = $root.lookupType('squareup.client.ClientAction.ViewStoredPaymentSettings');
fixType(ClientAction.ViewStoredPaymentSettings);
Builder.createAndAttachToType(ClientAction.ViewStoredPaymentSettings);
/**
 * SOURCE StartTapToPayTutorial @ squareup/client/client_action.proto at 1185:3
 */
ClientAction.StartTapToPayTutorial = $root.lookupType('squareup.client.ClientAction.StartTapToPayTutorial');
fixType(ClientAction.StartTapToPayTutorial);
Builder.createAndAttachToType(ClientAction.StartTapToPayTutorial);
/**
 * SOURCE ViewBfdDeviceSettings @ squareup/client/client_action.proto at 1192:3
 */
ClientAction.ViewBfdDeviceSettings = $root.lookupType('squareup.client.ClientAction.ViewBfdDeviceSettings');
fixType(ClientAction.ViewBfdDeviceSettings);
Builder.createAndAttachToType(ClientAction.ViewBfdDeviceSettings);
/**
 * SOURCE ViewBillPayApplet @ squareup/client/client_action.proto at 1198:3
 */
ClientAction.ViewBillPayApplet = $root.lookupType('squareup.client.ClientAction.ViewBillPayApplet');
fixType(ClientAction.ViewBillPayApplet);
Builder.createAndAttachToType(ClientAction.ViewBillPayApplet);
/**
 * SOURCE CreateBillPayBill @ squareup/client/client_action.proto at 1204:3
 */
ClientAction.CreateBillPayBill = $root.lookupType('squareup.client.ClientAction.CreateBillPayBill');
fixType(ClientAction.CreateBillPayBill);
Builder.createAndAttachToType(ClientAction.CreateBillPayBill);
/**
 * SOURCE ViewBillPayBill @ squareup/client/client_action.proto at 1210:3
 */
ClientAction.ViewBillPayBill = $root.lookupType('squareup.client.ClientAction.ViewBillPayBill');
fixType(ClientAction.ViewBillPayBill);
Builder.createAndAttachToType(ClientAction.ViewBillPayBill);
/**
 * SOURCE ViewRecurringInvoices @ squareup/client/client_action.proto at 1223:3
 */
ClientAction.ViewRecurringInvoices = $root.lookupType('squareup.client.ClientAction.ViewRecurringInvoices');
fixType(ClientAction.ViewRecurringInvoices);
Builder.createAndAttachToType(ClientAction.ViewRecurringInvoices);
/**
 * SOURCE ViewProjectsApplet @ squareup/client/client_action.proto at 1243:3
 */
ClientAction.ViewProjectsApplet = $root.lookupType('squareup.client.ClientAction.ViewProjectsApplet');
fixType(ClientAction.ViewProjectsApplet);
Builder.createAndAttachToType(ClientAction.ViewProjectsApplet);
/**
 * SOURCE CreateProject @ squareup/client/client_action.proto at 1249:3
 */
ClientAction.CreateProject = $root.lookupType('squareup.client.ClientAction.CreateProject');
fixType(ClientAction.CreateProject);
Builder.createAndAttachToType(ClientAction.CreateProject);
/**
 * SOURCE ViewMoreTab @ squareup/client/client_action.proto at 1255:3
 */
ClientAction.ViewMoreTab = $root.lookupType('squareup.client.ClientAction.ViewMoreTab');
fixType(ClientAction.ViewMoreTab);
Builder.createAndAttachToType(ClientAction.ViewMoreTab);
/**
 * SOURCE ViewBillPaySettings @ squareup/client/client_action.proto at 1261:3
 */
ClientAction.ViewBillPaySettings = $root.lookupType('squareup.client.ClientAction.ViewBillPaySettings');
fixType(ClientAction.ViewBillPaySettings);
Builder.createAndAttachToType(ClientAction.ViewBillPaySettings);
/**
 * SOURCE ViewEmailMarketingSettings @ squareup/client/client_action.proto at 1267:3
 */
ClientAction.ViewEmailMarketingSettings = $root.lookupType('squareup.client.ClientAction.ViewEmailMarketingSettings');
fixType(ClientAction.ViewEmailMarketingSettings);
Builder.createAndAttachToType(ClientAction.ViewEmailMarketingSettings);
/**
 * SOURCE ViewEmailMarketingAddOnsLibraryDetail @ squareup/client/client_action.proto at 1274:3
 */
ClientAction.ViewEmailMarketingAddOnsLibraryDetail = $root.lookupType('squareup.client.ClientAction.ViewEmailMarketingAddOnsLibraryDetail');
fixType(ClientAction.ViewEmailMarketingAddOnsLibraryDetail);
Builder.createAndAttachToType(ClientAction.ViewEmailMarketingAddOnsLibraryDetail);
/**
 * SOURCE ViewOfflineModeSettings @ squareup/client/client_action.proto at 1281:3
 */
ClientAction.ViewOfflineModeSettings = $root.lookupType('squareup.client.ClientAction.ViewOfflineModeSettings');
fixType(ClientAction.ViewOfflineModeSettings);
Builder.createAndAttachToType(ClientAction.ViewOfflineModeSettings);
/**
 * SOURCE ViewSquidNetworkSettings @ squareup/client/client_action.proto at 1287:3
 */
ClientAction.ViewSquidNetworkSettings = $root.lookupType('squareup.client.ClientAction.ViewSquidNetworkSettings');
fixType(ClientAction.ViewSquidNetworkSettings);
Builder.createAndAttachToType(ClientAction.ViewSquidNetworkSettings);
/**
 * SOURCE ViewSquidGeneralSettings @ squareup/client/client_action.proto at 1293:3
 */
ClientAction.ViewSquidGeneralSettings = $root.lookupType('squareup.client.ClientAction.ViewSquidGeneralSettings');
fixType(ClientAction.ViewSquidGeneralSettings);
Builder.createAndAttachToType(ClientAction.ViewSquidGeneralSettings);
/**
 * SOURCE ViewInformationRequestsSettings @ squareup/client/client_action.proto at 1299:3
 */
ClientAction.ViewInformationRequestsSettings = $root.lookupType('squareup.client.ClientAction.ViewInformationRequestsSettings');
fixType(ClientAction.ViewInformationRequestsSettings);
Builder.createAndAttachToType(ClientAction.ViewInformationRequestsSettings);
/**
 * SOURCE ViewEstimatesSettings @ squareup/client/client_action.proto at 1322:3
 */
ClientAction.ViewEstimatesSettings = $root.lookupType('squareup.client.ClientAction.ViewEstimatesSettings');
fixType(ClientAction.ViewEstimatesSettings);
Builder.createAndAttachToType(ClientAction.ViewEstimatesSettings);
/**
 * SOURCE ViewEstimatesAddOnsLibraryDetail @ squareup/client/client_action.proto at 1329:3
 */
ClientAction.ViewEstimatesAddOnsLibraryDetail = $root.lookupType('squareup.client.ClientAction.ViewEstimatesAddOnsLibraryDetail');
fixType(ClientAction.ViewEstimatesAddOnsLibraryDetail);
Builder.createAndAttachToType(ClientAction.ViewEstimatesAddOnsLibraryDetail);
/**
 * SOURCE ViewEstimatesApplet @ squareup/client/client_action.proto at 1336:3
 */
ClientAction.ViewEstimatesApplet = $root.lookupType('squareup.client.ClientAction.ViewEstimatesApplet');
fixType(ClientAction.ViewEstimatesApplet);
Builder.createAndAttachToType(ClientAction.ViewEstimatesApplet);
/**
 * SOURCE ViewBusinessInformationSettings @ squareup/client/client_action.proto at 1343:3
 */
ClientAction.ViewBusinessInformationSettings = $root.lookupType('squareup.client.ClientAction.ViewBusinessInformationSettings');
fixType(ClientAction.ViewBusinessInformationSettings);
Builder.createAndAttachToType(ClientAction.ViewBusinessInformationSettings);
/**
 * SOURCE ViewNotificationsApplet @ squareup/client/client_action.proto at 1349:3
 */
ClientAction.ViewNotificationsApplet = $root.lookupType('squareup.client.ClientAction.ViewNotificationsApplet');
fixType(ClientAction.ViewNotificationsApplet);
Builder.createAndAttachToType(ClientAction.ViewNotificationsApplet);
/**
 * SOURCE ViewRSTFloorPlansApplet @ squareup/client/client_action.proto at 1355:3
 */
ClientAction.ViewRSTFloorPlansApplet = $root.lookupType('squareup.client.ClientAction.ViewRSTFloorPlansApplet');
fixType(ClientAction.ViewRSTFloorPlansApplet);
Builder.createAndAttachToType(ClientAction.ViewRSTFloorPlansApplet);
/**
 * SOURCE ViewRSTChecksApplet @ squareup/client/client_action.proto at 1362:3
 */
ClientAction.ViewRSTChecksApplet = $root.lookupType('squareup.client.ClientAction.ViewRSTChecksApplet');
fixType(ClientAction.ViewRSTChecksApplet);
Builder.createAndAttachToType(ClientAction.ViewRSTChecksApplet);
/**
 * SOURCE ViewBillPayAddOnsLibraryDetail @ squareup/client/client_action.proto at 1369:3
 */
ClientAction.ViewBillPayAddOnsLibraryDetail = $root.lookupType('squareup.client.ClientAction.ViewBillPayAddOnsLibraryDetail');
fixType(ClientAction.ViewBillPayAddOnsLibraryDetail);
Builder.createAndAttachToType(ClientAction.ViewBillPayAddOnsLibraryDetail);
/**
 * SOURCE ViewConfigureCustomerProfile @ squareup/client/client_action.proto at 1375:5
 */
ClientAction.ViewConfigureCustomerProfile = $root.lookupType('squareup.client.ClientAction.ViewConfigureCustomerProfile');
fixType(ClientAction.ViewConfigureCustomerProfile);
Builder.createAndAttachToType(ClientAction.ViewConfigureCustomerProfile);
/**
 * SOURCE ViewRSTShiftReportApplet @ squareup/client/client_action.proto at 1382:3
 */
ClientAction.ViewRSTShiftReportApplet = $root.lookupType('squareup.client.ClientAction.ViewRSTShiftReportApplet');
fixType(ClientAction.ViewRSTShiftReportApplet);
Builder.createAndAttachToType(ClientAction.ViewRSTShiftReportApplet);
/**
 * SOURCE ViewIOSInvoiceDefaultPaymentMethods @ squareup/client/client_action.proto at 1389:3
 */
ClientAction.ViewIOSInvoiceDefaultPaymentMethods = $root.lookupType('squareup.client.ClientAction.ViewIOSInvoiceDefaultPaymentMethods');
fixType(ClientAction.ViewIOSInvoiceDefaultPaymentMethods);
Builder.createAndAttachToType(ClientAction.ViewIOSInvoiceDefaultPaymentMethods);
/**
 * SOURCE ViewIOSInvoicesAppletHomeTab @ squareup/client/client_action.proto at 1395:3
 */
ClientAction.ViewIOSInvoicesAppletHomeTab = $root.lookupType('squareup.client.ClientAction.ViewIOSInvoicesAppletHomeTab');
fixType(ClientAction.ViewIOSInvoicesAppletHomeTab);
Builder.createAndAttachToType(ClientAction.ViewIOSInvoicesAppletHomeTab);
/**
 * SOURCE ViewIOSInvoicesAppletHomeTabPromo @ squareup/client/client_action.proto at 1401:3
 */
ClientAction.ViewIOSInvoicesAppletHomeTabPromo = $root.lookupType('squareup.client.ClientAction.ViewIOSInvoicesAppletHomeTabPromo');
fixType(ClientAction.ViewIOSInvoicesAppletHomeTabPromo);
Builder.createAndAttachToType(ClientAction.ViewIOSInvoicesAppletHomeTabPromo);
/**
 * SOURCE ViewScannerScaleDeviceSettings @ squareup/client/client_action.proto at 1407:3
 */
ClientAction.ViewScannerScaleDeviceSettings = $root.lookupType('squareup.client.ClientAction.ViewScannerScaleDeviceSettings');
fixType(ClientAction.ViewScannerScaleDeviceSettings);
Builder.createAndAttachToType(ClientAction.ViewScannerScaleDeviceSettings);
/**
 * SOURCE ViewInventoryApplet @ squareup/client/client_action.proto at 1420:3
 */
ClientAction.ViewInventoryApplet = $root.lookupType('squareup.client.ClientAction.ViewInventoryApplet');
fixType(ClientAction.ViewInventoryApplet);
Builder.createAndAttachToType(ClientAction.ViewInventoryApplet);
/**
 * SOURCE InventoryFeature @ squareup/client/client_action.proto at 1426:5
 */
ClientAction.ViewInventoryApplet.InventoryFeature = $root.lookupEnum('squareup.client.ClientAction.ViewInventoryApplet.InventoryFeature').values;
/**
 * SOURCE ViewContractsSettings @ squareup/client/client_action.proto at 1453:3
 */
ClientAction.ViewContractsSettings = $root.lookupType('squareup.client.ClientAction.ViewContractsSettings');
fixType(ClientAction.ViewContractsSettings);
Builder.createAndAttachToType(ClientAction.ViewContractsSettings);
/**
 * SOURCE ViewContractsAddOnsLibraryDetail @ squareup/client/client_action.proto at 1459:3
 */
ClientAction.ViewContractsAddOnsLibraryDetail = $root.lookupType('squareup.client.ClientAction.ViewContractsAddOnsLibraryDetail');
fixType(ClientAction.ViewContractsAddOnsLibraryDetail);
Builder.createAndAttachToType(ClientAction.ViewContractsAddOnsLibraryDetail);
/**
 * SOURCE ViewContractsApplet @ squareup/client/client_action.proto at 1465:3
 */
ClientAction.ViewContractsApplet = $root.lookupType('squareup.client.ClientAction.ViewContractsApplet');
fixType(ClientAction.ViewContractsApplet);
Builder.createAndAttachToType(ClientAction.ViewContractsApplet);
/**
 * SOURCE ViewAIInsightOptIn @ squareup/client/client_action.proto at 1471:3
 */
ClientAction.ViewAIInsightOptIn = $root.lookupType('squareup.client.ClientAction.ViewAIInsightOptIn');
fixType(ClientAction.ViewAIInsightOptIn);
Builder.createAndAttachToType(ClientAction.ViewAIInsightOptIn);
/**
 * SOURCE ViewTerminalApiApplet @ squareup/client/client_action.proto at 1478:3
 */
ClientAction.ViewTerminalApiApplet = $root.lookupType('squareup.client.ClientAction.ViewTerminalApiApplet');
fixType(ClientAction.ViewTerminalApiApplet);
Builder.createAndAttachToType(ClientAction.ViewTerminalApiApplet);
/**
 * SOURCE ViewTerminalApiSettings @ squareup/client/client_action.proto at 1484:3
 */
ClientAction.ViewTerminalApiSettings = $root.lookupType('squareup.client.ClientAction.ViewTerminalApiSettings');
fixType(ClientAction.ViewTerminalApiSettings);
Builder.createAndAttachToType(ClientAction.ViewTerminalApiSettings);
/**
 * SOURCE PairR12 @ squareup/client/client_action.proto at 1490:3
 */
ClientAction.PairR12 = $root.lookupType('squareup.client.ClientAction.PairR12');
fixType(ClientAction.PairR12);
Builder.createAndAttachToType(ClientAction.PairR12);
/**
 * SOURCE ConfirmBankAccountChange @ squareup/client/client_action.proto at 1496:3
 */
ClientAction.ConfirmBankAccountChange = $root.lookupType('squareup.client.ClientAction.ConfirmBankAccountChange');
fixType(ClientAction.ConfirmBankAccountChange);
Builder.createAndAttachToType(ClientAction.ConfirmBankAccountChange);
/**
 * SOURCE OpenUniversalLink @ squareup/client/client_action.proto at 1508:3
 */
ClientAction.OpenUniversalLink = $root.lookupType('squareup.client.ClientAction.OpenUniversalLink');
fixType(ClientAction.OpenUniversalLink);
Builder.createAndAttachToType(ClientAction.OpenUniversalLink);
/**
 * SOURCE ViewTaxSettings @ squareup/client/client_action.proto at 1532:3
 */
ClientAction.ViewTaxSettings = $root.lookupType('squareup.client.ClientAction.ViewTaxSettings');
fixType(ClientAction.ViewTaxSettings);
Builder.createAndAttachToType(ClientAction.ViewTaxSettings);
/**
 * SOURCE ViewTapToPayAccountSettings @ squareup/client/client_action.proto at 1538:3
 */
ClientAction.ViewTapToPayAccountSettings = $root.lookupType('squareup.client.ClientAction.ViewTapToPayAccountSettings');
fixType(ClientAction.ViewTapToPayAccountSettings);
Builder.createAndAttachToType(ClientAction.ViewTapToPayAccountSettings);
/**
 * SOURCE ViewDiskSpaceWarning @ squareup/client/client_action.proto at 1544:3
 */
ClientAction.ViewDiskSpaceWarning = $root.lookupType('squareup.client.ClientAction.ViewDiskSpaceWarning');
fixType(ClientAction.ViewDiskSpaceWarning);
Builder.createAndAttachToType(ClientAction.ViewDiskSpaceWarning);
/**
 * SOURCE ViewInstantProfiles @ squareup/client/client_action.proto at 1550:3
 */
ClientAction.ViewInstantProfiles = $root.lookupType('squareup.client.ClientAction.ViewInstantProfiles');
fixType(ClientAction.ViewInstantProfiles);
Builder.createAndAttachToType(ClientAction.ViewInstantProfiles);
/**
 * SOURCE ViewCurrentShiftSettings @ squareup/client/client_action.proto at 1556:3
 */
ClientAction.ViewCurrentShiftSettings = $root.lookupType('squareup.client.ClientAction.ViewCurrentShiftSettings');
fixType(ClientAction.ViewCurrentShiftSettings);
Builder.createAndAttachToType(ClientAction.ViewCurrentShiftSettings);
/**
 * SOURCE ViewAppointment @ squareup/client/client_action.proto at 1562:3
 */
ClientAction.ViewAppointment = $root.lookupType('squareup.client.ClientAction.ViewAppointment');
fixType(ClientAction.ViewAppointment);
Builder.createAndAttachToType(ClientAction.ViewAppointment);
/**
 * SOURCE ViewFavoritesSettings @ squareup/client/client_action.proto at 1574:3
 */
ClientAction.ViewFavoritesSettings = $root.lookupType('squareup.client.ClientAction.ViewFavoritesSettings');
fixType(ClientAction.ViewFavoritesSettings);
Builder.createAndAttachToType(ClientAction.ViewFavoritesSettings);
/**
 * SOURCE ViewHardwareSettings @ squareup/client/client_action.proto at 1580:3
 */
ClientAction.ViewHardwareSettings = $root.lookupType('squareup.client.ClientAction.ViewHardwareSettings');
fixType(ClientAction.ViewHardwareSettings);
Builder.createAndAttachToType(ClientAction.ViewHardwareSettings);
/**
 * SOURCE ViewPaymentsCancellationsSettings @ squareup/client/client_action.proto at 1586:3
 */
ClientAction.ViewPaymentsCancellationsSettings = $root.lookupType('squareup.client.ClientAction.ViewPaymentsCancellationsSettings');
fixType(ClientAction.ViewPaymentsCancellationsSettings);
Builder.createAndAttachToType(ClientAction.ViewPaymentsCancellationsSettings);
/**
 * SOURCE ViewRetailSettings @ squareup/client/client_action.proto at 1592:3
 */
ClientAction.ViewRetailSettings = $root.lookupType('squareup.client.ClientAction.ViewRetailSettings');
fixType(ClientAction.ViewRetailSettings);
Builder.createAndAttachToType(ClientAction.ViewRetailSettings);
/**
 * SOURCE ViewRetailAddOnsLibraryDetail @ squareup/client/client_action.proto at 1599:3
 */
ClientAction.ViewRetailAddOnsLibraryDetail = $root.lookupType('squareup.client.ClientAction.ViewRetailAddOnsLibraryDetail');
fixType(ClientAction.ViewRetailAddOnsLibraryDetail);
Builder.createAndAttachToType(ClientAction.ViewRetailAddOnsLibraryDetail);
/**
 * SOURCE ViewRetailApplet @ squareup/client/client_action.proto at 1606:3
 */
ClientAction.ViewRetailApplet = $root.lookupType('squareup.client.ClientAction.ViewRetailApplet');
fixType(ClientAction.ViewRetailApplet);
Builder.createAndAttachToType(ClientAction.ViewRetailApplet);
/**
 * SOURCE ViewSquareCreditCardHome @ squareup/client/client_action.proto at 1613:3
 */
ClientAction.ViewSquareCreditCardHome = $root.lookupType('squareup.client.ClientAction.ViewSquareCreditCardHome');
fixType(ClientAction.ViewSquareCreditCardHome);
Builder.createAndAttachToType(ClientAction.ViewSquareCreditCardHome);
/**
 * SOURCE ActivateSquareCreditCard @ squareup/client/client_action.proto at 1619:3
 */
ClientAction.ActivateSquareCreditCard = $root.lookupType('squareup.client.ClientAction.ActivateSquareCreditCard');
fixType(ClientAction.ActivateSquareCreditCard);
Builder.createAndAttachToType(ClientAction.ActivateSquareCreditCard);
/**
 * SOURCE ViewAddOnDetail @ squareup/client/client_action.proto at 1625:3
 */
ClientAction.ViewAddOnDetail = $root.lookupType('squareup.client.ClientAction.ViewAddOnDetail');
fixType(ClientAction.ViewAddOnDetail);
Builder.createAndAttachToType(ClientAction.ViewAddOnDetail);
/**
 * SOURCE ViewAddOnSettings @ squareup/client/client_action.proto at 1637:3
 */
ClientAction.ViewAddOnSettings = $root.lookupType('squareup.client.ClientAction.ViewAddOnSettings');
fixType(ClientAction.ViewAddOnSettings);
Builder.createAndAttachToType(ClientAction.ViewAddOnSettings);
/**
 * SOURCE ViewStaffSettings @ squareup/client/client_action.proto at 1649:3
 */
ClientAction.ViewStaffSettings = $root.lookupType('squareup.client.ClientAction.ViewStaffSettings');
fixType(ClientAction.ViewStaffSettings);
Builder.createAndAttachToType(ClientAction.ViewStaffSettings);
/**
 * SOURCE ViewStaffAddOnsLibraryDetail @ squareup/client/client_action.proto at 1656:3
 */
ClientAction.ViewStaffAddOnsLibraryDetail = $root.lookupType('squareup.client.ClientAction.ViewStaffAddOnsLibraryDetail');
fixType(ClientAction.ViewStaffAddOnsLibraryDetail);
Builder.createAndAttachToType(ClientAction.ViewStaffAddOnsLibraryDetail);
/**
 * SOURCE ViewInvoiceAppearanceSettings @ squareup/client/client_action.proto at 1663:3
 */
ClientAction.ViewInvoiceAppearanceSettings = $root.lookupType('squareup.client.ClientAction.ViewInvoiceAppearanceSettings');
fixType(ClientAction.ViewInvoiceAppearanceSettings);
Builder.createAndAttachToType(ClientAction.ViewInvoiceAppearanceSettings);
/**
 * SOURCE ViewPaymentMethodsSettings @ squareup/client/client_action.proto at 1669:3
 */
ClientAction.ViewPaymentMethodsSettings = $root.lookupType('squareup.client.ClientAction.ViewPaymentMethodsSettings');
fixType(ClientAction.ViewPaymentMethodsSettings);
Builder.createAndAttachToType(ClientAction.ViewPaymentMethodsSettings);
/**
 * SOURCE ViewVariationsOptionsModifiersSettings @ squareup/client/client_action.proto at 1676:3
 */
ClientAction.ViewVariationsOptionsModifiersSettings = $root.lookupType('squareup.client.ClientAction.ViewVariationsOptionsModifiersSettings');
fixType(ClientAction.ViewVariationsOptionsModifiersSettings);
Builder.createAndAttachToType(ClientAction.ViewVariationsOptionsModifiersSettings);
/**
 * SOURCE ViewFulfillmentTypesSettings @ squareup/client/client_action.proto at 1683:3
 */
ClientAction.ViewFulfillmentTypesSettings = $root.lookupType('squareup.client.ClientAction.ViewFulfillmentTypesSettings');
fixType(ClientAction.ViewFulfillmentTypesSettings);
Builder.createAndAttachToType(ClientAction.ViewFulfillmentTypesSettings);
/**
 * SOURCE ViewLoanOfferSet @ squareup/client/client_action.proto at 1690:3
 */
ClientAction.ViewLoanOfferSet = $root.lookupType('squareup.client.ClientAction.ViewLoanOfferSet');
fixType(ClientAction.ViewLoanOfferSet);
Builder.createAndAttachToType(ClientAction.ViewLoanOfferSet);
/**
 * SOURCE ViewSuperPOSCustomerSurvey @ squareup/client/client_action.proto at 1702:3
 */
ClientAction.ViewSuperPOSCustomerSurvey = $root.lookupType('squareup.client.ClientAction.ViewSuperPOSCustomerSurvey');
fixType(ClientAction.ViewSuperPOSCustomerSurvey);
Builder.createAndAttachToType(ClientAction.ViewSuperPOSCustomerSurvey);
/**
 * SOURCE ViewAppointmentsSettings @ squareup/client/client_action.proto at 1709:3
 */
ClientAction.ViewAppointmentsSettings = $root.lookupType('squareup.client.ClientAction.ViewAppointmentsSettings');
fixType(ClientAction.ViewAppointmentsSettings);
Builder.createAndAttachToType(ClientAction.ViewAppointmentsSettings);
/**
 * SOURCE ViewAppointmentsHoursSettings @ squareup/client/client_action.proto at 1716:3
 */
ClientAction.ViewAppointmentsHoursSettings = $root.lookupType('squareup.client.ClientAction.ViewAppointmentsHoursSettings');
fixType(ClientAction.ViewAppointmentsHoursSettings);
Builder.createAndAttachToType(ClientAction.ViewAppointmentsHoursSettings);
/**
 * SOURCE CreateAppointment @ squareup/client/client_action.proto at 1723:3
 */
ClientAction.CreateAppointment = $root.lookupType('squareup.client.ClientAction.CreateAppointment');
fixType(ClientAction.CreateAppointment);
Builder.createAndAttachToType(ClientAction.CreateAppointment);
/**
 * SOURCE Feature @ squareup/client/client_action.proto at 1724:5
 */
ClientAction.CreateAppointment.Feature = $root.lookupEnum('squareup.client.ClientAction.CreateAppointment.Feature').values;
/**
 * SOURCE CreateClass @ squareup/client/client_action.proto at 1771:3
 */
ClientAction.CreateClass = $root.lookupType('squareup.client.ClientAction.CreateClass');
fixType(ClientAction.CreateClass);
Builder.createAndAttachToType(ClientAction.CreateClass);
/**
 * SOURCE Feature @ squareup/client/client_action.proto at 1772:5
 */
ClientAction.CreateClass.Feature = $root.lookupEnum('squareup.client.ClientAction.CreateClass.Feature').values;
/**
 * SOURCE ViewOrderHardware @ squareup/client/client_action.proto at 1805:3
 */
ClientAction.ViewOrderHardware = $root.lookupType('squareup.client.ClientAction.ViewOrderHardware');
fixType(ClientAction.ViewOrderHardware);
Builder.createAndAttachToType(ClientAction.ViewOrderHardware);